var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSegmentsBannerDarkLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 234,
    height: 141,
    viewBox: "0 0 234 141",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2708_26814)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2708_26814",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 234,
    height: 141,
    fill: "#ffffff"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H234V141H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2708_26814)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5917 76.7356C83.9255 76.7356 83.9255 75.7643 84.5917 75.7643C85.2579 75.7643 85.2579 76.7356 84.5917 76.7356Z",
    fill: "url(#pattern0)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5874 59.3165C90.5173 59.3165 90.4471 59.3165 90.377 59.3165C89.816 59.3165 89.2901 58.8632 89.3251 58.3452C89.3602 57.8272 89.781 57.3738 90.377 57.3738C90.4471 57.3738 90.5173 57.3738 90.5874 57.3738C91.1484 57.3738 91.6743 57.8272 91.6393 58.3452C91.6042 58.8632 91.1835 59.3165 90.5874 59.3165Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.2368 64.2703C88.8693 64.2703 88.8693 62.3276 90.2368 62.3276C91.6042 62.3276 91.6042 64.2703 90.2368 64.2703Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.4822 68.9002C89.1148 68.9002 89.1148 66.9576 90.4822 66.9576C91.8146 66.9576 91.8146 68.9002 90.4822 68.9002Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.6772 66.5367C86.3097 66.5367 86.3097 64.5941 87.6772 64.5941C89.0446 64.5941 89.0446 66.5367 87.6772 66.5367Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.2228 64.2703C83.8554 64.2703 83.8554 62.3276 85.2228 62.3276C86.5552 62.3276 86.5903 64.2703 85.2228 64.2703Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.6633 61.68C81.2958 61.68 81.2958 59.7374 82.6633 59.7374C83.9956 59.7374 83.9956 61.68 82.6633 61.68Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.0797 60.9353C89.0797 60.9678 89.0797 61.0001 89.0797 61.0325C89.0797 61.5506 88.5888 62.0362 88.0278 62.0038C87.4668 61.9714 86.976 61.5829 86.976 61.0325C86.976 61.0001 86.976 60.9678 86.976 60.9353C86.976 60.4173 87.4668 59.9316 88.0278 59.964C88.5888 59.9964 89.0797 60.385 89.0797 60.9353Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.5384 59.7373C85.5033 59.7373 85.4683 59.7373 85.4332 59.7373C84.8722 59.7373 84.3463 59.2841 84.3813 58.766C84.4164 58.248 84.8371 57.7947 85.4332 57.7947C85.4683 57.7947 85.5033 57.7947 85.5384 57.7947C86.0994 57.7947 86.6253 58.248 86.5903 58.766C86.5903 59.2841 86.1344 59.7373 85.5384 59.7373Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.8737 57.0501C81.5062 57.0501 81.5062 55.1074 82.8737 55.1074C84.2411 55.1074 84.2411 57.0501 82.8737 57.0501Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.2257 53.8122C81.2257 53.8447 81.2257 53.877 81.2257 53.9093C81.2257 54.4275 80.7348 54.9131 80.1738 54.8807C79.6128 54.8483 79.122 54.4598 79.122 53.9093C79.122 53.877 79.122 53.8447 79.122 53.8122C79.122 53.2942 79.6128 52.8085 80.1738 52.8409C80.7699 52.8733 81.2257 53.2619 81.2257 53.8122Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5091 50.5745C77.5441 50.5745 77.5792 50.5745 77.6143 50.5745C78.1753 50.5745 78.7012 51.0278 78.6661 51.5458C78.6311 52.0639 78.2103 52.5171 77.6143 52.5171C77.5792 52.5171 77.5441 52.5171 77.5091 52.5171C76.9481 52.5171 76.4221 52.0639 76.4572 51.5458C76.4923 51.0278 76.913 50.5745 77.5091 50.5745Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.0547 48.3081C75.0898 48.3081 75.1248 48.3081 75.1599 48.3081C75.7209 48.3081 76.2468 48.7613 76.2118 49.2794C76.1767 49.7975 75.756 50.2508 75.1599 50.2508C75.1248 50.2508 75.0898 50.2508 75.0547 50.2508C74.4937 50.2508 73.9678 49.7975 74.0028 49.2794C74.0379 48.729 74.4587 48.3081 75.0547 48.3081Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.0278 57.0501C86.6604 57.0501 86.6604 55.1074 88.0278 55.1074C89.3602 55.1074 89.3602 57.0501 88.0278 57.0501Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.4332 54.9778C84.0658 54.9778 84.0658 53.0352 85.4332 53.0352C86.8007 53.0352 86.8007 54.9778 85.4332 54.9778Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.9788 52.8086C81.6114 52.8086 81.6114 50.8659 82.9788 50.8659C84.3463 50.8659 84.3463 52.8086 82.9788 52.8086Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.9634 50.7688C78.596 50.7688 78.596 48.8261 79.9634 48.8261C81.3309 48.8261 81.3309 50.7688 79.9634 50.7688Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.1864 70.422C87.1864 70.3897 87.1864 70.3573 87.1864 70.3249C87.1864 69.8069 87.6772 69.3212 88.2382 69.3536C88.7992 69.3859 89.2901 69.7745 89.2901 70.3249C89.2901 70.3573 89.2901 70.3897 89.2901 70.422C89.2901 70.9401 88.7992 71.4257 88.2382 71.3934C87.6772 71.361 87.1864 70.9725 87.1864 70.422Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.328 69.1269C83.9606 69.1269 83.9606 67.1842 85.328 67.1842C86.6954 67.1842 86.6954 69.1269 85.328 69.1269Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.523 66.2453C81.1556 66.2453 81.1556 64.3026 82.523 64.3026C83.8904 64.3026 83.8904 66.2453 82.523 66.2453Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.3141 64.2703C78.9466 64.2703 78.9466 62.3276 80.3141 62.3276C81.6464 62.3276 81.6464 64.2703 80.3141 64.2703Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.7195 61.9067C76.352 61.9067 76.352 59.964 77.7195 59.964C79.0869 59.964 79.0869 61.9067 77.7195 61.9067Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.2651 59.7373C73.8976 59.7373 73.8976 57.7947 75.2651 57.7947C76.6325 57.7947 76.6325 59.7373 75.2651 59.7373Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.7574 56.4025C73.7574 56.4348 73.7574 56.4673 73.7574 56.4996C73.7574 57.0176 73.2665 57.5033 72.7055 57.471C72.1445 57.4386 71.6536 57.0501 71.6536 56.4996C71.6536 56.4673 71.6536 56.4348 71.6536 56.4025C71.6536 55.8845 72.1445 55.3988 72.7055 55.4312C73.2665 55.4312 73.7574 55.852 73.7574 56.4025Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2511 55.075C68.8837 55.075 68.8837 53.1323 70.2511 53.1323C71.5835 53.1323 71.6186 55.075 70.2511 55.075Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.3141 59.2193C78.9466 59.2193 78.9466 57.2767 80.3141 57.2767C81.6464 57.2767 81.6464 59.2193 80.3141 59.2193Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.0168 56.4025C79.0168 56.4348 79.0168 56.4673 79.0168 56.4996C79.0168 57.0176 78.5259 57.5033 77.9649 57.471C77.4039 57.4386 76.913 57.0501 76.913 56.4996C76.913 56.4673 76.913 56.4348 76.913 56.4025C76.913 55.8845 77.4039 55.3988 77.9649 55.4312C78.5259 55.4312 79.0168 55.852 79.0168 56.4025Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.4222 54.1036C76.4222 54.1361 76.4222 54.1684 76.4222 54.2008C76.4222 54.7189 75.9313 55.2045 75.3703 55.1721C74.8093 55.1398 74.3184 54.7512 74.3184 54.2008C74.3184 54.1684 74.3184 54.1361 74.3184 54.1036C74.3184 53.5856 74.8093 53.1 75.3703 53.1324C75.9664 53.1647 76.4222 53.5856 76.4222 54.1036Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.7055 52.8086C71.3381 52.8086 71.3381 50.8659 72.7055 50.8659C74.0729 50.8659 74.0729 52.8086 72.7055 52.8086Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.133 76.1529C86.7656 76.1529 86.7656 74.2103 88.133 74.2103C89.4654 74.2103 89.4654 76.1529 88.133 76.1529Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.0475 73.6922C85.0125 73.6598 84.9774 73.6274 84.9423 73.5951C84.5566 73.2389 84.5216 72.5913 84.9423 72.2352C85.3631 71.879 86.0293 71.8467 86.4149 72.2352C86.45 72.2676 86.4851 72.2999 86.5201 72.3323C86.9058 72.6884 86.9409 73.336 86.5201 73.6922C86.0994 74.0483 85.4332 74.0807 85.0475 73.6922Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.9789 69.5479C83.0139 69.5479 83.049 69.5479 83.084 69.5479C83.645 69.5479 84.171 70.0012 84.1359 70.5192C84.1009 71.0372 83.6801 71.4905 83.084 71.4905C83.049 71.4905 83.0139 71.4905 82.9789 71.4905C82.4179 71.4905 81.8919 71.0372 81.927 70.5192C81.962 70.0012 82.3828 69.5479 82.9789 69.5479Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.4726 68.2527C79.4726 68.2203 79.4726 68.188 79.4726 68.1556C79.4726 67.6375 79.9635 67.1518 80.5245 67.1843C81.0855 67.2166 81.5764 67.6052 81.5764 68.1556C81.5764 68.188 81.5764 68.2203 81.5764 68.2527C81.5764 68.7708 81.0855 69.2564 80.5245 69.224C79.9635 69.1916 79.4726 68.8031 79.4726 68.2527Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.7714 65.5654C78.7714 65.5977 78.7714 65.6301 78.7714 65.6625C78.7714 66.1805 78.2805 66.6662 77.7195 66.6339C77.1585 66.6014 76.6676 66.2129 76.6676 65.6625C76.6676 65.6301 76.6676 65.5977 76.6676 65.5654C76.6676 65.0474 77.1585 64.5617 77.7195 64.5941C78.3156 64.6264 78.7714 65.0149 78.7714 65.5654Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.1599 64.1731C73.7925 64.1731 73.7925 62.2305 75.1599 62.2305C76.5273 62.2305 76.5273 64.1731 75.1599 64.1731Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.9159 62.1009C71.5485 62.1009 71.5485 60.1583 72.9159 60.1583C74.2833 60.1583 74.2833 62.1009 72.9159 62.1009Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4615 59.9316C69.0941 59.9316 69.0941 57.989 70.4615 57.989C71.829 57.989 71.829 59.9316 70.4615 59.9316Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4462 57.1472C66.0787 57.1472 66.0787 55.2045 67.4462 55.2045C68.8136 55.2045 68.8136 57.1472 67.4462 57.1472Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9918 53.1323C65.0269 53.1323 65.0619 53.1323 65.097 53.1323C65.658 53.1323 66.1839 53.5856 66.1489 54.1037C66.1138 54.6218 65.693 55.075 65.097 55.075C65.0619 55.075 65.0269 55.075 64.9918 55.075C64.4308 55.075 63.9049 54.6218 63.9399 54.1037C63.975 53.5856 64.3957 53.1323 64.9918 53.1323Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.1864 79.7144C87.1864 79.6821 87.1864 79.6497 87.1864 79.6173C87.1864 79.0993 87.6772 78.6136 88.2382 78.6459C88.7992 78.6784 89.2901 79.0669 89.2901 79.6173C89.2901 79.6497 89.2901 79.6821 89.2901 79.7144C89.2901 80.2325 88.7992 80.7182 88.2382 80.6857C87.6772 80.6534 87.1864 80.2649 87.1864 79.7144Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.7839 78.5165C84.4164 78.5165 84.4164 76.5738 85.7839 76.5738C87.1162 76.5738 87.1162 78.5165 85.7839 78.5165Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.8737 75.7319C81.5062 75.7319 81.5062 73.7892 82.8737 73.7892C84.2411 73.7892 84.2411 75.7319 82.8737 75.7319Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.3141 73.6598C78.9466 73.6598 78.9466 71.7171 80.3141 71.7171C81.6464 71.7171 81.6464 73.6598 80.3141 73.6598Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8597 69.4507C77.8948 69.4507 77.9298 69.4507 77.9649 69.4507C78.5259 69.4507 79.0518 69.904 79.0168 70.422C78.9817 70.94 78.561 71.3934 77.9649 71.3934C77.9298 71.3934 77.8948 71.3934 77.8597 71.3934C77.2987 71.3934 76.7728 70.94 76.8078 70.422C76.8078 69.904 77.2636 69.4507 77.8597 69.4507Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.3703 69.0298C74.0029 69.0298 74.0029 67.0871 75.3703 67.0871C76.7377 67.0871 76.7377 69.0298 75.3703 69.0298Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.0561 66.8604C71.6887 66.8604 71.6887 64.9178 73.0561 64.9178C74.3885 64.9178 74.3885 66.8604 73.0561 66.8604Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.146 64.1731C70.1109 64.1731 70.0759 64.1731 70.0408 64.1731C69.4798 64.1731 68.9539 63.7198 68.9889 63.2018C69.024 62.6837 69.4447 62.2305 70.0408 62.2305C70.0759 62.2305 70.1109 62.2305 70.146 62.2305C70.707 62.2305 71.2329 62.6837 71.1979 63.2018C71.1628 63.7198 70.7421 64.1731 70.146 64.1731Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.6916 62.1009C66.3241 62.1009 66.3241 60.1583 67.6916 60.1583C69.024 60.1583 69.024 62.1009 67.6916 62.1009Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9385 58.4423C65.9385 58.4746 65.9385 58.507 65.9385 58.5394C65.9385 59.0574 65.4476 59.5431 64.8866 59.5108C64.3256 59.4783 63.8347 59.0898 63.8347 58.5394C63.8347 58.507 63.8347 58.4746 63.8347 58.4423C63.8347 57.9242 64.3256 57.4385 64.8866 57.471C65.4476 57.5033 65.9385 57.9242 65.9385 58.4423Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.0633 55.3017C63.0984 55.334 63.1335 55.3665 63.1685 55.3988C63.5542 55.7549 63.5893 56.4025 63.1685 56.7587C62.7478 57.1148 62.0816 57.1472 61.6959 56.7587C61.6608 56.7262 61.6258 56.6939 61.5907 56.6615C61.205 56.3054 61.17 55.6579 61.5907 55.3017C61.9764 54.9455 62.6426 54.9131 63.0633 55.3017Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8727 55.075C58.5052 55.075 58.5052 53.1323 59.8727 53.1323C61.205 53.1323 61.205 55.075 59.8727 55.075Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3832 52.7114C56.0158 52.7114 56.0158 50.7687 57.3832 50.7687C58.7507 50.7687 58.7507 52.7114 57.3832 52.7114Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5081 50.0242C53.1407 50.0242 53.1407 48.0815 54.5081 48.0815C55.8405 48.0815 55.8405 50.0242 54.5081 50.0242Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7199 47.9842C52.6848 47.9842 52.6498 47.9842 52.6147 47.9842C52.0537 47.9842 51.5278 47.531 51.5628 47.0129C51.5979 46.4949 52.0187 46.0416 52.6147 46.0416C52.6498 46.0416 52.6848 46.0416 52.7199 46.0416C53.2809 46.0416 53.8068 46.4949 53.7718 47.0129C53.7367 47.531 53.2809 47.9842 52.7199 47.9842Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.2368 87.5822C88.8693 87.5822 88.8693 85.6395 90.2368 85.6395C91.6042 85.6395 91.6042 87.5822 90.2368 87.5822Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.3434 85.6396C86.9759 85.6396 86.9759 83.6969 88.3434 83.6969C89.7108 83.6969 89.7108 85.6396 88.3434 85.6396Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.328 83.0493C83.9606 83.0493 83.9606 81.1066 85.328 81.1066C86.6954 81.1066 86.6954 83.0493 85.328 83.0493Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.8737 80.6857C81.5062 80.6857 81.5062 78.743 82.8737 78.743C84.2411 78.743 84.2411 80.6857 82.8737 80.6857Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.7349 78.6136C79.3674 78.6136 79.3674 76.6709 80.7349 76.6709C82.1023 76.6709 82.1023 78.6136 80.7349 78.6136Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.2272 75.3758C79.2272 75.4082 79.2272 75.4405 79.2272 75.473C79.2272 75.991 78.7363 76.4766 78.1753 76.4443C77.6143 76.4119 77.1234 76.0233 77.1234 75.473C77.1234 75.4405 77.1234 75.4082 77.1234 75.3758C77.1234 74.8577 77.6143 74.3721 78.1753 74.4045C78.7363 74.4368 79.2272 74.8254 79.2272 75.3758Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.1599 73.5627C73.7925 73.5627 73.7925 71.62 75.1599 71.62C76.5273 71.62 76.5273 73.5627 75.1599 73.5627Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.9159 71.5876C71.5485 71.5876 71.5485 69.645 72.9159 69.645C74.2833 69.645 74.2833 71.5876 72.9159 71.5876Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.146 68.706C70.1109 68.706 70.0759 68.706 70.0408 68.706C69.4798 68.706 68.9539 68.2527 68.9889 67.7346C69.024 67.2166 69.4447 66.7633 70.0408 66.7633C70.0759 66.7633 70.1109 66.7633 70.146 66.7633C70.707 66.7633 71.2329 67.2166 71.1979 67.7346C71.1628 68.2527 70.7421 68.706 70.146 68.706Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7968 66.8604C66.4294 66.8604 66.4294 64.9178 67.7968 64.9178C69.1292 64.9178 69.1292 66.8604 67.7968 66.8604Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9918 64.3674C63.6243 64.3674 63.6243 62.4247 64.9918 62.4247C66.3592 62.4247 66.3592 64.3674 64.9918 64.3674Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5374 61.9067C61.17 61.9067 61.17 59.964 62.5374 59.964C63.9048 59.964 63.9048 61.9067 62.5374 61.9067Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8727 59.6402C58.5052 59.6402 58.5052 57.6976 59.8727 57.6976C61.205 57.6976 61.205 59.6402 59.8727 59.6402Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7521 56.9853C56.717 56.953 56.682 56.9205 56.6469 56.8882C56.2612 56.532 56.2262 55.8845 56.6469 55.5283C57.0677 55.1721 57.7339 55.1398 58.1195 55.5283C58.1546 55.5606 58.1897 55.5931 58.2247 55.6254C58.6104 55.9816 58.6455 56.6291 58.2247 56.9853C57.839 57.3415 57.1728 57.3415 56.7521 56.9853Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6133 54.7835C53.2458 54.7835 53.2458 52.8409 54.6133 52.8409C55.9456 52.8409 55.9456 54.7835 54.6133 54.7835Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7199 52.8086C51.3525 52.8086 51.3525 50.8659 52.7199 50.8659C54.0523 50.8659 54.0523 52.8086 52.7199 52.8086Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1253 50.3479C50.0902 50.3479 50.0552 50.3479 50.0201 50.3479C49.4591 50.3479 48.9332 49.8946 48.9682 49.3765C49.0033 48.8584 49.424 48.4052 50.0201 48.4052C50.0552 48.4052 50.0902 48.4052 50.1253 48.4052C50.6863 48.4052 51.2122 48.8584 51.1772 49.3765C51.1772 49.8946 50.7214 50.3479 50.1253 50.3479Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6556 50.1536C43.2881 50.1536 43.2881 48.2109 44.6556 48.2109C46.023 48.2109 46.023 50.1536 44.6556 50.1536Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4606 52.5171C46.0931 52.5171 46.0931 50.5745 47.4606 50.5745C48.7929 50.5745 48.828 52.5171 47.4606 52.5171Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1253 54.8807C50.0902 54.8807 50.0552 54.8807 50.0201 54.8807C49.4591 54.8807 48.9332 54.4275 48.9682 53.9094C49.0033 53.3914 49.424 52.938 50.0201 52.938C50.0552 52.938 50.0902 52.938 50.1253 52.938C50.6863 52.938 51.2122 53.3914 51.1772 53.9094C51.1772 54.4275 50.7214 54.8807 50.1253 54.8807Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9303 57.3738C51.5629 57.3738 51.5629 55.4312 52.9303 55.4312C54.2977 55.4312 54.2977 57.3738 52.9303 57.3738Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.0734 58.9603C49.0734 58.928 49.0734 58.8955 49.0734 58.8632C49.0734 58.3452 49.5643 57.8595 50.1253 57.8918C50.6863 57.9242 51.1772 58.3127 51.1772 58.8632C51.1772 58.8955 51.1772 58.928 51.1772 58.9603C51.1772 59.4783 50.6863 59.964 50.1253 59.9317C49.5643 59.9317 49.0734 59.5108 49.0734 58.9603Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6709 57.3738C46.3035 57.3738 46.3035 55.4312 47.6709 55.4312C49.0383 55.4312 49.0383 57.3738 47.6709 57.3738Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.9193 53.3266C43.9543 53.2943 43.9894 53.2619 44.0244 53.2295C44.4101 52.8734 45.1114 52.841 45.4971 53.2295C45.8828 53.618 45.9178 54.2332 45.4971 54.5893C45.462 54.6218 45.4269 54.6541 45.3919 54.6865C45.0062 55.0427 44.3049 55.075 43.9193 54.6865C43.5336 54.3304 43.4985 53.7151 43.9193 53.3266Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3063 52.8086C40.9389 52.8086 40.9389 50.8659 42.3063 50.8659C43.6738 50.8659 43.6738 52.8086 42.3063 52.8086Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3554 59.7374C47.3904 59.7374 47.4255 59.7374 47.4606 59.7374C48.0216 59.7374 48.5475 60.1907 48.5124 60.7087C48.4774 61.2267 48.0566 61.68 47.4606 61.68C47.4255 61.68 47.3904 61.68 47.3554 61.68C46.7944 61.68 46.2684 61.2267 46.3035 60.7087C46.3035 60.1907 46.7593 59.7374 47.3554 59.7374Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5796 62.0038C51.2122 62.0038 51.2122 60.0611 52.5796 60.0611C53.9471 60.0611 53.9471 62.0038 52.5796 62.0038Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2656 64.4646C50.2305 64.4646 50.1954 64.4646 50.1604 64.4646C49.5994 64.4646 49.0734 64.0113 49.1085 63.4932C49.1436 62.9752 49.5643 62.5219 50.1604 62.5219C50.1954 62.5219 50.2305 62.5219 50.2656 62.5219C50.8266 62.5219 51.3525 62.9752 51.3174 63.4932C51.2824 64.0437 50.8266 64.4646 50.2656 64.4646Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8755 63.4931C55.8755 63.5256 55.8755 63.5579 55.8755 63.5903C55.8755 64.1084 55.3847 64.594 54.8237 64.5616C54.2627 64.5292 53.7718 64.1407 53.7718 63.5903C53.7718 63.5579 53.7718 63.5256 53.7718 63.4931C53.7718 62.9751 54.2627 62.4894 54.8237 62.5218C55.3847 62.5542 55.8755 62.9751 55.8755 63.4931Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7199 66.8604C51.3525 66.8604 51.3525 64.9178 52.7199 64.9178C54.0523 64.9178 54.0523 66.8604 52.7199 66.8604Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0201 69.1269C48.6527 69.1269 48.6527 67.1842 50.0201 67.1842C51.3876 67.1842 51.3876 69.1269 50.0201 69.1269Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5796 71.2962C51.2122 71.2962 51.2122 69.3536 52.5796 69.3536C53.9471 69.3536 53.9471 71.2962 52.5796 71.2962Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2656 73.6598C48.8981 73.6598 48.8981 71.7171 50.2656 71.7171C51.5979 71.7171 51.5979 73.6598 50.2656 73.6598Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5235 71.1991C56.156 71.1991 56.156 69.2565 57.5235 69.2565C58.8559 69.2565 58.8559 71.1991 57.5235 71.1991Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3328 72.7856C54.3328 72.7532 54.3328 72.7208 54.3328 72.6884C54.3328 72.1704 54.8236 71.6848 55.3846 71.7171C55.9456 71.7495 56.4365 72.138 56.4365 72.6884C56.4365 72.7208 56.4365 72.7532 56.4365 72.7856C56.4365 73.3036 55.9456 73.7893 55.3846 73.7569C54.8236 73.7246 54.3328 73.336 54.3328 72.7856Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9836 75.1815C51.9836 75.1492 51.9836 75.1168 51.9836 75.0844C51.9836 74.5664 52.4745 74.0807 53.0355 74.113C53.5965 74.1455 54.0873 74.534 54.0873 75.0844C54.0873 75.1168 54.0873 75.1492 54.0873 75.1815C54.0873 75.6996 53.5965 76.1853 53.0355 76.1528C52.4745 76.1205 51.9836 75.6996 51.9836 75.1815Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1253 78.5165C48.7579 78.5165 48.7579 76.5738 50.1253 76.5738C51.4927 76.5738 51.4927 78.5165 50.1253 78.5165Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7761 80.4591C46.4087 80.4591 46.4087 78.5165 47.7761 78.5165C49.1436 78.5165 49.1436 80.4591 47.7761 80.4591Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9164 76.1529C46.5489 76.1529 46.5489 74.2103 47.9164 74.2103C49.2487 74.2103 49.2487 76.1529 47.9164 76.1529Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0201 85.9634C50.0552 85.9634 50.0902 85.9634 50.1253 85.9634C50.6863 85.9634 51.2122 86.4166 51.1772 86.9347C51.1421 87.4527 50.7214 87.906 50.1253 87.906C50.0902 87.906 50.0552 87.906 50.0201 87.906C49.4591 87.906 48.9332 87.4527 48.9682 86.9347C49.0033 86.3843 49.424 85.9634 50.0201 85.9634Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3707 83.1464C49.0033 83.1464 49.0033 81.2037 50.3707 81.2037C51.7031 81.2037 51.7031 83.1464 50.3707 83.1464Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.7718 84.2473C53.7718 84.2797 53.7718 84.3121 53.7718 84.3445C53.7718 84.8625 53.2809 85.3482 52.7199 85.3158C52.1589 85.2835 51.668 84.8949 51.668 84.3445C51.668 84.3121 51.668 84.2797 51.668 84.2473C51.668 83.7293 52.1589 83.2437 52.7199 83.276C53.2809 83.3084 53.7718 83.6969 53.7718 84.2473Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7199 90.5933C51.3525 90.5933 51.3525 88.6506 52.7199 88.6506C54.0523 88.6506 54.0523 90.5933 52.7199 90.5933Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0158 87.6146C55.9807 87.647 55.9457 87.6794 55.9106 87.7117C55.5249 88.0679 54.8237 88.1002 54.438 87.7117C54.0523 87.3232 54.0172 86.708 54.438 86.3518C54.4731 86.3195 54.5081 86.2871 54.5432 86.2547C54.9289 85.8986 55.6301 85.8662 56.0158 86.2547C56.4015 86.6432 56.4366 87.226 56.0158 87.6146Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2795 90.4962C55.3146 90.4962 55.3496 90.4962 55.3847 90.4962C55.9457 90.4962 56.4716 90.9495 56.4366 91.4675C56.4015 91.9856 55.9808 92.4389 55.3847 92.4389C55.3496 92.4389 55.3146 92.4389 55.2795 92.4389C54.7185 92.4389 54.1926 91.9856 54.2276 91.4675C54.2627 90.9495 54.6834 90.4962 55.2795 90.4962Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7199 94.8027C51.3525 94.8027 51.3525 92.86 52.7199 92.86C54.0523 92.86 54.0523 94.8027 52.7199 94.8027Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0018 96.8099C50.9668 96.8421 50.9317 96.8744 50.8966 96.9066C50.5109 97.2633 49.8097 97.2955 49.424 96.9066C49.0383 96.5186 49.0033 95.903 49.424 95.5473C49.4591 95.515 49.4941 95.4828 49.5292 95.4496C49.9149 95.0939 50.6161 95.0616 51.0018 95.4496C51.3875 95.8063 51.4226 96.421 51.0018 96.8099Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5657 99.335C46.1983 99.335 46.1983 97.3923 47.5657 97.3923C48.9332 97.3923 48.9332 99.335 47.5657 99.335Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.375 96.4864C44.34 96.4542 44.3049 96.421 44.2698 96.3887C43.8842 96.033 43.8491 95.3851 44.2698 95.0294C44.6906 94.6728 45.3568 94.6405 45.7425 95.0294C45.7775 95.0617 45.8126 95.0939 45.8477 95.1262C46.2333 95.4828 46.2684 96.1298 45.8477 96.4864C45.4269 96.8421 44.7958 96.8744 44.375 96.4864Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2795 68.8031C53.912 68.8031 53.912 66.8605 55.2795 66.8605C56.6469 66.8605 56.6469 68.8031 55.2795 68.8031Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7339 66.7633C56.3664 66.7633 56.3664 64.8207 57.7339 64.8207C59.1013 64.8207 59.1013 66.7633 57.7339 66.7633Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8727 64.3674C58.5052 64.3674 58.5052 62.4247 59.8727 62.4247C61.205 62.4247 61.205 64.3674 59.8727 64.3674Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.6286 62.0038C56.2612 62.0038 56.2612 60.0611 57.6286 60.0611C58.961 60.0611 58.961 62.0038 57.6286 62.0038Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9288 59.8345C53.5614 59.8345 53.5614 57.8918 54.9288 57.8918C56.2963 57.8918 56.2963 59.8345 54.9288 59.8345Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5374 66.5367C61.17 66.5367 61.17 64.5941 62.5374 64.5941C63.9048 64.5941 63.9048 66.5367 62.5374 66.5367Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2401 67.6375C61.2401 67.67 61.2401 67.7023 61.2401 67.7347C61.2401 68.2527 60.7492 68.7384 60.1882 68.706C59.6272 68.6737 59.1364 68.2851 59.1364 67.7347C59.1364 67.7023 59.1364 67.67 59.1364 67.6375C59.1364 67.1195 59.6272 66.6339 60.1882 66.6662C60.7492 66.6986 61.2401 67.0872 61.2401 67.6375Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7632 69.5478C65.7281 69.5478 65.6931 69.5478 65.658 69.5478C65.097 69.5478 64.5711 69.0945 64.6061 68.5765C64.6412 68.0584 65.0619 67.6052 65.658 67.6052C65.6931 67.6052 65.7281 67.6052 65.7632 67.6052C66.3242 67.6052 66.8501 68.0584 66.8151 68.5765C66.8151 69.0945 66.3592 69.5478 65.7632 69.5478Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.6426 69.7421C62.6777 69.7421 62.7127 69.7421 62.7478 69.7421C63.3088 69.7421 63.8347 70.1954 63.7997 70.7135C63.7646 71.2315 63.3439 71.6848 62.7478 71.6848C62.7127 71.6848 62.6777 71.6848 62.6426 71.6848C62.0816 71.6848 61.5557 71.2315 61.5907 70.7135C61.6258 70.1954 62.0465 69.7421 62.6426 69.7421Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5389 73.854C59.1714 73.854 59.1714 71.9114 60.5389 71.9114C61.8712 71.9114 61.8712 73.854 60.5389 73.854Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7857 74.534C58.7857 74.5664 58.7857 74.5988 58.7857 74.6311C58.7857 75.1492 58.2948 75.6348 57.7338 75.6025C57.1728 75.5701 56.682 75.1816 56.682 74.6311C56.682 74.5988 56.682 74.5664 56.682 74.534C56.682 74.016 57.1728 73.5303 57.7338 73.5627C58.2948 73.5951 58.7857 74.016 58.7857 74.534Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0508 77.6746C56.0158 77.6746 55.9807 77.6746 55.9456 77.6746C55.3847 77.6746 54.8587 77.2214 54.8938 76.7033C54.9288 76.1853 55.3496 75.7319 55.9456 75.7319C55.9807 75.7319 56.0158 75.7319 56.0508 75.7319C56.6118 75.7319 57.1378 76.1853 57.1027 76.7033C57.0676 77.2537 56.6469 77.6746 56.0508 77.6746Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9303 80.6857C51.5629 80.6857 51.5629 78.743 52.9303 78.743C54.2977 78.743 54.2977 80.6857 52.9303 80.6857Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0691 83.0493C53.7016 83.0493 53.7016 81.1066 55.0691 81.1066C56.4015 81.1066 56.4015 83.0493 55.0691 83.0493Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7339 78.6459C57.7689 78.6459 57.804 78.6459 57.839 78.6459C58.4 78.6459 58.926 79.0993 58.8909 79.6173C58.8559 80.1354 58.4351 80.5886 57.839 80.5886C57.804 80.5886 57.7689 80.5886 57.7339 80.5886C57.1729 80.5886 56.6469 80.1354 56.682 79.6173C56.717 79.0669 57.1378 78.6459 57.7339 78.6459Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0831 78.4194C58.7156 78.4194 58.7156 76.4767 60.0831 76.4767C61.4505 76.4767 61.4505 78.4194 60.0831 78.4194Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7478 76.25C61.3804 76.25 61.3804 74.3073 62.7478 74.3073C64.1152 74.3073 64.1152 76.25 62.7478 76.25Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.097 72.1381C65.132 72.1381 65.1671 72.1381 65.2021 72.1381C65.7631 72.1381 66.2891 72.5913 66.254 73.1094C66.219 73.6274 65.7982 74.0807 65.2021 74.0807C65.1671 74.0807 65.132 74.0807 65.097 74.0807C64.536 74.0807 64.01 73.6274 64.0451 73.1094C64.0801 72.5913 64.5009 72.1381 65.097 72.1381Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.2358 71.8143C65.8683 71.8143 65.8683 69.8716 67.2358 69.8716C68.5681 69.8716 68.6032 71.8143 67.2358 71.8143Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7589 73.0123C71.7589 73.0446 71.7589 73.077 71.7589 73.1094C71.7589 73.6274 71.268 74.1131 70.707 74.0808C70.146 74.0483 69.6551 73.6598 69.6551 73.1094C69.6551 73.077 69.6551 73.0446 69.6551 73.0123C69.6551 72.4942 70.146 72.0085 70.707 72.041C71.268 72.041 71.7589 72.4618 71.7589 73.0123Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0071 75.9262C66.6397 75.9262 66.6397 73.9835 68.0071 73.9835C69.3746 73.9835 69.3746 75.9262 68.0071 75.9262Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9918 78.2898C63.6243 78.2898 63.6243 76.3472 64.9918 76.3472C66.3592 76.3472 66.3592 78.2898 64.9918 78.2898Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.6426 80.5886C62.5724 80.5886 62.5023 80.5886 62.4322 80.5886C61.8712 80.5886 61.3453 80.1354 61.3803 79.6173C61.4154 79.0993 61.8361 78.6459 62.4322 78.6459C62.5023 78.6459 62.5724 78.6459 62.6426 78.6459C63.2036 78.6459 63.7295 79.0993 63.6944 79.6173C63.6594 80.1354 63.2386 80.5886 62.6426 80.5886Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2401 81.7542C61.2401 81.7866 61.2401 81.819 61.2401 81.8513C61.2401 82.3694 60.7492 82.8551 60.1882 82.8226C59.6272 82.7903 59.1364 82.4018 59.1364 81.8513C59.1364 81.819 59.1364 81.7866 59.1364 81.7542C59.1364 81.2362 59.6272 80.7505 60.1882 80.7828C60.7492 80.8153 61.2401 81.2362 61.2401 81.7542Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3832 85.9309C56.0158 85.9309 56.0158 83.9883 57.3832 83.9883C58.7507 83.9883 58.7507 85.9309 57.3832 85.9309Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0831 87.4851C58.7156 87.4851 58.7156 85.5424 60.0831 85.5424C61.4505 85.5424 61.4505 87.4851 60.0831 87.4851Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.0845 89.8486C56.717 89.8486 56.717 87.9059 58.0845 87.9059C59.4168 87.9059 59.4168 89.8486 58.0845 89.8486Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5389 92.2444C59.1714 92.2444 59.1714 90.3019 60.5389 90.3019C61.8712 90.3019 61.8712 92.2444 60.5389 92.2444Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.9413 88.3916C62.6426 88.1974 63.3088 88.7155 63.3088 89.363C63.3088 90.0106 62.6426 90.5286 61.9413 90.3343C61.4154 90.1724 61.0297 89.6544 61.205 89.1363C61.3803 88.6507 61.9413 88.2945 62.5023 88.4564C62.5023 88.4564 62.5023 88.4564 62.5374 88.4564C62.2569 88.4888 62.0115 88.5212 61.731 88.5535C61.5907 88.683 61.4855 88.7802 61.3453 88.9097C61.3102 88.9744 61.2752 89.0716 61.2401 89.1363C61.2401 89.1363 61.2401 89.1364 61.2401 89.104C61.2401 89.2011 61.205 89.2658 61.205 89.363C61.205 89.363 61.205 89.363 61.205 89.3306C61.2401 89.4925 61.3102 89.6544 61.3453 89.8163C61.4855 89.9458 61.5907 90.0429 61.731 90.1724C62.0115 90.2048 62.2569 90.2372 62.5374 90.2695C62.5374 90.2695 62.5374 90.2695 62.5023 90.2695C61.9764 90.3991 61.3453 90.1077 61.205 89.5897C61.0648 89.0716 61.3803 88.5212 61.9413 88.3916Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6805 93.8314C58.6805 93.8636 58.6805 93.8959 58.6805 93.9281C58.6805 94.4461 58.1897 94.9317 57.6287 94.8995C57.0677 94.8672 56.5768 94.4783 56.5768 93.9281C56.5768 93.8959 56.5768 93.8636 56.5768 93.8314C56.5768 93.3135 57.0677 92.8278 57.6287 92.86C58.1897 92.8923 58.6805 93.2803 58.6805 93.8314Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9288 97.2956C53.5614 97.2956 53.5614 95.3529 54.9288 95.3529C56.2963 95.3529 56.2963 97.2956 54.9288 97.2956Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9303 99.1415C51.5629 99.1415 51.5629 97.1988 52.9303 97.1988C54.2977 97.1988 54.2977 99.1415 52.9303 99.1415Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1253 101.731C48.7579 101.731 48.7579 99.7884 50.1253 99.7884C51.4927 99.7884 51.4927 101.731 50.1253 101.731Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7199 103.9C51.3525 103.9 51.3525 101.958 52.7199 101.958C54.0523 101.958 54.0523 103.9 52.7199 103.9Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9288 106.459C53.5614 106.459 53.5614 104.516 54.9288 104.516C56.2963 104.516 56.2963 106.459 54.9288 106.459Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0677 108.434C55.7002 108.434 55.7002 106.491 57.0677 106.491C58.4351 106.491 58.4351 108.434 57.0677 108.434Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.9246 109.534C60.9246 109.566 60.9246 109.599 60.9246 109.632C60.9246 110.15 60.4337 110.635 59.8727 110.603C59.3117 110.571 58.8208 110.182 58.8208 109.632C58.8208 109.599 58.8208 109.566 58.8208 109.534C58.8208 109.016 59.3117 108.53 59.8727 108.563C60.4337 108.563 60.9246 108.984 60.9246 109.534Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.888 108.725C61.5206 108.725 61.5206 106.782 62.888 106.782C64.2204 106.782 64.2204 108.725 62.888 108.725Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1349 105.487C61.1349 105.52 61.1349 105.552 61.1349 105.584C61.1349 106.102 60.644 106.588 60.083 106.555C59.522 106.523 59.0311 106.134 59.0311 105.584C59.0311 105.552 59.0311 105.52 59.0311 105.487C59.0311 104.969 59.522 104.484 60.083 104.516C60.644 104.548 61.1349 104.936 61.1349 105.487Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6805 102.929C58.6805 102.961 58.6805 102.994 58.6805 103.027C58.6805 103.545 58.1897 104.03 57.6287 103.998C57.0677 103.965 56.5768 103.577 56.5768 103.027C56.5768 102.994 56.5768 102.961 56.5768 102.929C56.5768 102.411 57.0677 101.926 57.6287 101.958C58.1897 101.958 58.6805 102.379 58.6805 102.929Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0691 101.829C53.7016 101.829 53.7016 99.886 55.0691 99.886C56.4015 99.886 56.4015 101.829 55.0691 101.829Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5235 99.335C56.156 99.335 56.156 97.3923 57.5235 97.3923C58.8559 97.3923 58.8559 99.335 57.5235 99.335Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.2934 101.926C58.926 101.926 58.926 99.9828 60.2934 99.9828C61.6608 99.9828 61.6608 101.926 60.2934 101.926Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.327 103.771C60.9596 103.771 60.9596 101.829 62.327 101.829C63.6594 101.829 63.6594 103.771 62.327 103.771Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.9918 104.516C65.0269 104.516 65.0619 104.516 65.097 104.516C65.658 104.516 66.1839 104.969 66.1489 105.487C66.1138 106.005 65.693 106.459 65.097 106.459C65.0619 106.459 65.0269 106.459 64.9918 106.459C64.4308 106.459 63.9049 106.005 63.9399 105.487C63.975 104.969 64.3957 104.516 64.9918 104.516Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4995 103.22C66.4995 103.188 66.4995 103.156 66.4995 103.124C66.4995 102.606 66.9903 102.12 67.5513 102.152C68.1123 102.184 68.6032 102.573 68.6032 103.124C68.6032 103.156 68.6032 103.188 68.6032 103.22C68.6032 103.738 68.1123 104.224 67.5513 104.192C66.9903 104.159 66.4995 103.771 66.4995 103.22Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2021 101.829C63.8347 101.829 63.8347 99.886 65.2021 99.886C66.5696 99.886 66.5696 101.829 65.2021 101.829Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.6426 99.335C61.2752 99.335 61.2752 97.3923 62.6426 97.3923C64.0101 97.3923 64.0101 99.335 62.6426 99.335Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2415 96.3242C59.2415 96.292 59.2415 96.2597 59.2415 96.2275C59.2415 95.7086 59.7324 95.2229 60.2934 95.2561C60.8544 95.2884 61.3453 95.6764 61.3453 96.2275C61.3453 96.2597 61.3453 96.292 61.3453 96.3242C61.3453 96.8421 60.8544 97.3278 60.2934 97.2956C59.7324 97.2633 59.2415 96.8744 59.2415 96.3242Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5374 94.8027C61.17 94.8027 61.17 92.86 62.5374 92.86C63.9048 92.86 63.9048 94.8027 62.5374 94.8027Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7814 96.7776C63.414 96.7776 63.414 94.835 64.7814 94.835C66.1138 94.835 66.1138 96.7776 64.7814 96.7776Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0071 99.2382C66.6397 99.2382 66.6397 97.2955 68.0071 97.2955C69.3746 97.2955 69.3746 99.2382 68.0071 99.2382Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.146 101.408C68.7785 101.408 68.7785 99.4649 70.146 99.4649C71.4784 99.4649 71.4784 101.408 70.146 101.408Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.8107 104.289C71.4433 104.289 71.4433 102.347 72.8107 102.347C74.1782 102.347 74.1782 104.289 72.8107 104.289Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2512 104.322C70.2863 104.322 70.3213 104.322 70.3564 104.322C70.9174 104.322 71.4433 104.775 71.4083 105.293C71.3732 105.811 70.9524 106.264 70.3564 106.264C70.3213 106.264 70.2863 106.264 70.2512 106.264C69.6902 106.264 69.1643 105.811 69.1993 105.293C69.2344 104.775 69.6551 104.322 70.2512 104.322Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.902 108.952C66.5345 108.952 66.5345 107.009 67.902 107.009C69.2694 107.009 69.2694 108.952 67.902 108.952Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4476 110.991C64.0802 110.991 64.0802 109.048 65.4476 109.048C66.78 109.048 66.815 110.991 65.4476 110.991Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4462 113.16C66.0787 113.16 66.0787 111.218 67.4462 111.218C68.8136 111.218 68.8136 113.16 67.4462 113.16Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9005 111.315C68.5331 111.315 68.5331 109.373 69.9005 109.373C71.2679 109.373 71.2679 111.315 69.9005 111.315Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5667 115.33C69.1993 115.33 69.1993 113.387 70.5667 113.387C71.9341 113.387 71.9341 115.33 70.5667 115.33Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.1614 113.808C71.7939 113.808 71.7939 111.866 73.1614 111.866C74.4937 111.866 74.4937 113.808 73.1614 113.808Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.7055 115.654C72.7406 115.654 72.7757 115.654 72.8107 115.654C73.3717 115.654 73.8977 116.107 73.8626 116.625C73.8275 117.143 73.4068 117.597 72.8107 117.597C72.7757 117.597 72.7406 117.597 72.7055 117.597C72.1445 117.597 71.6186 117.143 71.6537 116.625C71.6887 116.107 72.1095 115.654 72.7055 115.654Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.3703 116.269C74.0029 116.269 74.0029 114.326 75.3703 114.326C76.7377 114.326 76.7377 116.269 75.3703 116.269Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.9649 118.244C76.5975 118.244 76.5975 116.301 77.9649 116.301C79.2973 116.301 79.2973 118.244 77.9649 118.244Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.8737 118.244C81.5062 118.244 81.5062 116.301 82.8737 116.301C84.2411 116.301 84.2411 118.244 82.8737 118.244Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.6296 116.172C79.2622 116.172 79.2622 114.229 80.6296 114.229C81.9971 114.229 81.9971 116.172 80.6296 116.172Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.8468 115.848C94.4794 115.848 94.4794 113.905 95.8468 113.905C97.1792 113.905 97.1792 115.848 95.8468 115.848Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5874 115.848C89.22 115.848 89.22 113.905 90.5874 113.905C91.9198 113.905 91.9198 115.848 90.5874 115.848Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.9366 113.064C91.5691 113.064 91.5691 111.121 92.9366 111.121C94.2689 111.121 94.2689 113.064 92.9366 113.064Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.2858 110.505C93.9183 110.505 93.9183 108.563 95.2858 108.563C96.6181 108.563 96.6181 110.505 95.2858 110.505Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.9885 107.883C93.9885 107.916 93.9885 107.948 93.9885 107.98C93.9885 108.498 93.4976 108.984 92.9366 108.952C92.3756 108.919 91.8847 108.53 91.8847 107.98C91.8847 107.948 91.8847 107.916 91.8847 107.883C91.8847 107.365 92.3756 106.879 92.9366 106.912C93.4976 106.912 93.9885 107.332 93.9885 107.883Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.6926 111.315C89.3251 111.315 89.3251 109.373 90.6926 109.373C92.06 109.373 92.06 111.315 90.6926 111.315Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.4668 113.16C86.0994 113.16 86.0994 111.218 87.4668 111.218C88.7992 111.218 88.7992 113.16 87.4668 113.16Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.0293 114.78C86.0293 114.812 86.0293 114.844 86.0293 114.876C86.0293 115.394 85.5384 115.88 84.9774 115.848C84.4164 115.815 83.9255 115.427 83.9255 114.876C83.9255 114.844 83.9255 114.812 83.9255 114.78C83.9255 114.262 84.4164 113.776 84.9774 113.808C85.5735 113.84 86.0293 114.229 86.0293 114.78Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.084 113.678C81.7166 113.678 81.7166 111.736 83.084 111.736C84.4515 111.736 84.4515 113.678 83.084 113.678Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.4193 110.991C79.0519 110.991 79.0519 109.048 80.4193 109.048C81.7517 109.048 81.7867 110.991 80.4193 110.991Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.5259 109.243C77.1585 109.243 77.1585 107.3 78.5259 107.3C79.8583 107.3 79.8583 109.243 78.5259 109.243Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5091 113.582C76.1417 113.582 76.1417 111.639 77.5091 111.639C78.8765 111.639 78.8765 113.582 77.5091 113.582Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.0547 110.894C73.6873 110.894 73.6873 108.952 75.0547 108.952C76.4222 108.952 76.4222 110.894 75.0547 110.894Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.7055 108.725C71.3381 108.725 71.3381 106.782 72.7055 106.782C74.0729 106.782 74.0729 108.725 72.7055 108.725Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.5105 105.843C74.1431 105.843 74.1431 103.9 75.5105 103.9C76.8429 103.9 76.8429 105.843 75.5105 105.843Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.2651 99.6917C75.3002 99.6917 75.3352 99.6917 75.3703 99.6917C75.9313 99.6917 76.4572 100.145 76.4222 100.663C76.3871 101.181 75.9664 101.634 75.3703 101.634C75.3352 101.634 75.3002 101.634 75.2651 101.634C74.7041 101.634 74.1782 101.181 74.2132 100.663C74.2483 100.113 74.669 99.6917 75.2651 99.6917Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0043 98.2668C72.0043 98.2346 72.0043 98.2023 72.0043 98.1701C72.0043 97.6512 72.4952 97.1656 73.0562 97.1988C73.6172 97.231 74.108 97.619 74.108 98.1701C74.108 98.2023 74.108 98.2346 74.108 98.2668C74.108 98.7848 73.6172 99.2704 73.0562 99.2382C72.4601 99.2382 72.0043 98.817 72.0043 98.2668Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9005 96.4532C68.5331 96.4532 68.5331 94.5115 69.9005 94.5115C71.2679 94.5115 71.2679 96.4532 69.9005 96.4532Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2891 93.4102C66.2891 93.378 66.2891 93.3457 66.2891 93.3135C66.2891 92.7946 66.7799 92.3089 67.3409 92.3421C67.9019 92.3744 68.3928 92.7624 68.3928 93.3135C68.3928 93.3457 68.3928 93.378 68.3928 93.4102C68.3928 93.9281 67.9019 94.4138 67.3409 94.3816C66.7799 94.3816 66.2891 93.9604 66.2891 93.4102Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.097 92.1151C63.7295 92.1151 63.7295 90.1725 65.097 90.1725C66.4644 90.1725 66.4644 92.1151 65.097 92.1151Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2021 87.906C63.8347 87.906 63.8347 85.9634 65.2021 85.9634C66.5696 85.9634 66.5696 87.906 65.2021 87.906Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.9932 85.8338C61.6258 85.8338 61.6258 83.8911 62.9932 83.8911C64.3256 83.8911 64.3256 85.8338 62.9932 85.8338Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.4461 87.7117C67.4812 87.7117 67.5163 87.7117 67.5513 87.7117C68.1123 87.7117 68.6383 88.165 68.6032 88.683C68.5681 89.201 68.1474 89.6543 67.5513 89.6543C67.5163 89.6543 67.4812 89.6543 67.4461 89.6543C66.8851 89.6543 66.3592 89.201 66.3943 88.683C66.4293 88.165 66.8501 87.7117 67.4461 87.7117Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2511 92.2444C68.8837 92.2444 68.8837 90.3019 70.2511 90.3019C71.5835 90.3019 71.6186 92.2444 70.2511 92.2444Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.7055 94.3815C71.3381 94.3815 71.3381 92.4388 72.7055 92.4388C74.0729 92.4388 74.0729 94.3815 72.7055 94.3815Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.1599 96.7776C73.7925 96.7776 73.7925 94.835 75.1599 94.835C76.5273 94.835 76.5273 96.7776 75.1599 96.7776Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1402 97.1656C78.1753 97.1988 78.2104 97.2311 78.2454 97.2633C78.6311 97.619 78.6662 98.2669 78.2454 98.6226C77.8247 98.9793 77.1585 99.0115 76.7728 98.6226C76.7377 98.5904 76.7027 98.5581 76.6676 98.5259C76.2819 98.1701 76.2469 97.5223 76.6676 97.1656C77.0884 96.8099 77.7195 96.7776 78.1402 97.1656Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.9102 100.533C80.9102 100.598 80.9102 100.663 80.9102 100.727C80.9102 101.245 80.4193 101.731 79.8583 101.699C79.2973 101.667 78.8064 101.278 78.8064 100.727C78.8064 100.663 78.8064 100.598 78.8064 100.533C78.8064 100.015 79.2973 99.5294 79.8583 99.5617C80.4193 99.594 80.9102 100.015 80.9102 100.533Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.0168 102.702C79.0168 102.735 79.0168 102.767 79.0168 102.8C79.0168 103.318 78.5259 103.804 77.9649 103.771C77.4039 103.738 76.913 103.35 76.913 102.8C76.913 102.767 76.913 102.735 76.913 102.702C76.913 102.184 77.4039 101.699 77.9649 101.731C78.5259 101.763 79.0168 102.152 79.0168 102.702Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.6296 106.264C79.2622 106.264 79.2622 104.322 80.6296 104.322C81.9971 104.322 81.9971 106.264 80.6296 106.264Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.6633 104.71C81.2958 104.71 81.2958 102.767 82.6633 102.767C83.9956 102.767 83.9956 104.71 82.6633 104.71Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.8737 108.336C81.5062 108.336 81.5062 106.393 82.8737 106.393C84.2411 106.393 84.2411 108.336 82.8737 108.336Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.1177 106.167C83.7502 106.167 83.7502 104.224 85.1177 104.224C86.45 104.224 86.45 106.167 85.1177 106.167Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.7839 111.218C84.4164 111.218 84.4164 109.275 85.7839 109.275C87.1162 109.275 87.1162 111.218 85.7839 111.218Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.572 108.855C86.2046 108.855 86.2046 106.912 87.572 106.912C88.9044 106.912 88.9044 108.855 87.572 108.855Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.6926 106.264C90.6575 106.264 90.6224 106.264 90.5874 106.264C90.0264 106.264 89.5004 105.811 89.5355 105.293C89.5706 104.775 89.9913 104.322 90.5874 104.322C90.6224 104.322 90.6575 104.322 90.6926 104.322C91.2536 104.322 91.7795 104.775 91.7444 105.293C91.7094 105.811 91.2886 106.264 90.6926 106.264Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.8876 103.9C86.5201 103.9 86.5201 101.958 87.8876 101.958C89.255 101.958 89.255 103.9 87.8876 103.9Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.2228 101.311C83.8554 101.311 83.8554 99.3682 85.2228 99.3682C86.5552 99.3682 86.5903 101.311 85.2228 101.311Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.7166 98.4936C81.7166 98.4613 81.7166 98.4291 81.7166 98.3968C81.7166 97.878 82.2074 97.3923 82.7684 97.4255C83.3294 97.4578 83.8203 97.8457 83.8203 98.3968C83.8203 98.4291 83.8203 98.4613 83.8203 98.4936C83.8203 99.0115 83.3294 99.4972 82.7684 99.4649C82.1724 99.4327 81.7166 99.0115 81.7166 98.4936Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.1739 95.0294C80.2089 95.0294 80.244 95.0294 80.279 95.0294C80.84 95.0294 81.366 95.4828 81.3309 96.0008C81.2959 96.5187 80.8751 96.9721 80.279 96.9721C80.244 96.9721 80.2089 96.9721 80.1739 96.9721C79.6129 96.9721 79.0869 96.5187 79.122 96.0008C79.157 95.4828 79.6129 95.0294 80.1739 95.0294Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5091 94.5115C76.1417 94.5115 76.1417 92.5688 77.5091 92.5688C78.8765 92.5688 78.8765 94.5115 77.5091 94.5115Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.9495 92.018C73.5821 92.018 73.5821 90.0753 74.9495 90.0753C76.2819 90.0753 76.2819 92.018 74.9495 92.018Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.8107 90.0754C71.4433 90.0754 71.4433 88.1327 72.8107 88.1327C74.1782 88.1327 74.1782 90.0754 72.8107 90.0754Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5667 88.1002C69.1993 88.1002 69.1993 86.1575 70.5667 86.1575C71.9341 86.1575 71.9341 88.1002 70.5667 88.1002Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5513 85.3158C66.1839 85.3158 66.1839 83.3731 67.5513 83.3731C68.9188 83.3731 68.9188 85.3158 67.5513 85.3158Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4476 83.3731C64.0802 83.3731 64.0802 81.4305 65.4476 81.4305C66.78 81.4305 66.815 83.3731 65.4476 83.3731Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7968 80.4591C66.4294 80.4591 66.4294 78.5165 67.7968 78.5165C69.1292 78.5165 69.1292 80.4591 67.7968 80.4591Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0744 82.4018C72.0744 82.4341 72.0744 82.4665 72.0744 82.4989C72.0744 83.0169 71.5835 83.5026 71.0225 83.4702C70.4615 83.4378 69.9707 83.0493 69.9707 82.4989C69.9707 82.4665 69.9707 82.4341 69.9707 82.4018C69.9707 81.8837 70.4615 81.398 71.0225 81.4304C71.5835 81.4304 72.0744 81.8513 72.0744 82.4018Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6536 84.5387C71.6536 84.5064 71.6536 84.474 71.6536 84.4416C71.6536 83.9236 72.1445 83.4379 72.7055 83.4703C73.2665 83.5026 73.7574 83.8912 73.7574 84.4416C73.7574 84.474 73.7574 84.5064 73.7574 84.5387C73.7574 85.0568 73.2665 85.5424 72.7055 85.5101C72.1445 85.5101 71.6536 85.0892 71.6536 84.5387Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.2651 87.8088C73.8976 87.8088 73.8976 85.8663 75.2651 85.8663C76.6325 85.8663 76.6325 87.8088 75.2651 87.8088Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5091 89.7515C76.1417 89.7515 76.1417 87.8088 77.5091 87.8088C78.8765 87.8088 78.8765 89.7515 77.5091 89.7515Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.5245 92.8601C79.157 92.8601 79.157 90.9171 80.5245 90.9171C81.8919 90.9171 81.8919 92.8601 80.5245 92.8601Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.4178 94.705C81.0504 94.705 81.0504 92.7623 82.4178 92.7623C83.7853 92.7623 83.7853 94.705 82.4178 94.705Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.2228 97.1988C83.8554 97.1988 83.8554 95.2561 85.2228 95.2561C86.5552 95.2561 86.5903 97.1988 85.2228 97.1988Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.572 99.335C86.2046 99.335 86.2046 97.3923 87.572 97.3923C88.9044 97.3923 88.9044 99.335 87.572 99.335Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.2368 101.731C88.8693 101.731 88.8693 99.7884 90.2368 99.7884C91.6042 99.7884 91.6042 101.731 90.2368 101.731Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.5327 102.8C93.5327 102.832 93.5327 102.865 93.5327 102.897C93.5327 103.415 93.0418 103.9 92.4808 103.868C91.9198 103.836 91.4289 103.447 91.4289 102.897C91.4289 102.865 91.4289 102.832 91.4289 102.8C91.4289 102.282 91.9198 101.796 92.4808 101.829C93.0418 101.861 93.5327 102.282 93.5327 102.8Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.9366 99.5617C91.5691 99.5617 91.5691 97.619 92.9366 97.619C94.2689 97.619 94.2689 99.5617 92.9366 99.5617Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.5355 96.3242C89.5355 96.292 89.5355 96.2597 89.5355 96.2275C89.5355 95.7086 90.0264 95.2229 90.5874 95.2561C91.1484 95.2884 91.6393 95.6764 91.6393 96.2275C91.6393 96.2597 91.6393 96.292 91.6393 96.3242C91.6393 96.8421 91.1484 97.3278 90.5874 97.2956C90.0264 97.2633 89.5355 96.8744 89.5355 96.3242Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.9395 93.3135C88.9395 93.3457 88.9395 93.378 88.9395 93.4102C88.9395 93.9281 88.4486 94.4138 87.8876 94.3816C87.3266 94.3493 86.8357 93.9604 86.8357 93.4102C86.8357 93.378 86.8357 93.3457 86.8357 93.3135C86.8357 92.7946 87.3266 92.3089 87.8876 92.3421C88.4836 92.3744 88.9395 92.7624 88.9395 93.3135Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.1177 92.2444C83.7502 92.2444 83.7502 90.3019 85.1177 90.3019C86.45 90.3019 86.45 92.2444 85.1177 92.2444Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.6114 88.683C81.6114 88.6507 81.6114 88.6183 81.6114 88.5859C81.6114 88.0679 82.1023 87.5822 82.6633 87.6146C83.2243 87.647 83.7151 88.0355 83.7151 88.5859C83.7151 88.6183 83.7151 88.6507 83.7151 88.683C83.7151 89.2011 83.2243 89.6868 82.6633 89.6544C82.0672 89.622 81.6114 89.2335 81.6114 88.683Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.5427 86.9994C79.5076 86.967 79.4726 86.9346 79.4375 86.9023C79.0518 86.5461 79.0168 85.8985 79.4375 85.5424C79.8583 85.1862 80.5244 85.1539 80.9101 85.5424C80.9452 85.5747 80.9803 85.6071 81.0153 85.6395C81.401 85.9956 81.4361 86.6432 81.0153 86.9994C80.6296 87.3555 79.9634 87.3879 79.5427 86.9994Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1753 85.8338C76.8079 85.8338 76.8079 83.8911 78.1753 83.8911C79.5427 83.8911 79.5427 85.8338 78.1753 85.8338Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.0547 82.8551C73.6873 82.8551 73.6873 80.9125 75.0547 80.9125C76.4222 80.9125 76.4222 82.8551 75.0547 82.8551Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.9159 80.6857C71.5485 80.6857 71.5485 78.743 72.9159 78.743C74.2833 78.743 74.2833 80.6857 72.9159 80.6857Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9889 77.2214C68.9889 77.189 68.9889 77.1566 68.9889 77.1242C68.9889 76.6062 69.4798 76.1206 70.0408 76.1529C70.6018 76.1852 71.0927 76.5738 71.0927 77.1242C71.0927 77.1566 71.0927 77.189 71.0927 77.2214C71.0927 77.7394 70.6018 78.225 70.0408 78.1927C69.4447 78.1927 68.9889 77.7718 68.9889 77.2214Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.3549 75.9262C70.9875 75.9262 70.9875 73.9835 72.3549 73.9835C73.7224 73.9835 73.7224 75.9262 72.3549 75.9262Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6157 78.8078C75.5807 78.8078 75.5456 78.8078 75.5105 78.8078C74.9495 78.8078 74.4236 78.3546 74.4587 77.8365C74.4937 77.3185 74.9145 76.8652 75.5105 76.8652C75.5456 76.8652 75.5807 76.8652 75.6157 76.8652C76.1767 76.8652 76.7027 77.3185 76.6676 77.8365C76.6325 78.387 76.2118 78.8078 75.6157 78.8078Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.9649 80.6857C76.5975 80.6857 76.5975 78.743 77.9649 78.743C79.2973 78.743 79.2973 80.6857 77.9649 80.6857Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.1738 83.0493C78.8064 83.0493 78.8064 81.1066 80.1738 81.1066C81.5413 81.1066 81.5413 83.0493 80.1738 83.0493Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.9788 85.3158C82.9438 85.3158 82.9087 85.3158 82.8736 85.3158C82.3126 85.3158 81.7867 84.8625 81.8218 84.3444C81.8568 83.8264 82.2776 83.3731 82.8736 83.3731C82.9087 83.3731 82.9438 83.3731 82.9788 83.3731C83.5398 83.3731 84.0658 83.8264 84.0307 84.3444C83.9956 84.8625 83.5749 85.3158 82.9788 85.3158Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.328 87.8088C83.9606 87.8088 83.9606 85.8663 85.328 85.8663C86.6954 85.8663 86.6954 87.8088 85.328 87.8088Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.1162 89.6543C85.7488 89.6543 85.7488 87.7117 87.1162 87.7117C88.4836 87.7117 88.4836 89.6543 87.1162 89.6543Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.4822 92.4389C89.1148 92.4389 89.1148 90.4962 90.4822 90.4962C91.8146 90.4962 91.8146 92.4389 90.4822 92.4389Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3274 118.179C35.96 118.179 35.96 116.237 37.3274 116.237C38.6949 116.237 38.6949 118.179 37.3274 118.179Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.803 115.686C33.4356 115.686 33.4356 113.744 34.803 113.744C36.1705 113.744 36.1705 115.686 34.803 115.686Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.0302 118.729C36.0302 118.762 36.0302 118.794 36.0302 118.794C36.0302 119.313 35.5393 119.798 34.9783 119.765C34.4173 119.733 33.9264 119.345 33.9264 118.794C33.9264 118.762 33.9264 118.729 33.9264 118.729C33.9264 118.211 34.4173 117.726 34.9783 117.758C35.5393 117.79 36.0302 118.179 36.0302 118.729Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2026 120.186C38.8351 120.186 38.8351 118.244 40.2026 118.244C41.57 118.244 41.57 120.186 40.2026 120.186Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7271 122.356C41.3597 122.356 41.3597 120.413 42.7271 120.413C44.0945 120.413 44.0945 122.356 42.7271 122.356Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.4971 124.784C44.1296 124.784 44.1296 122.841 45.4971 122.841C46.8645 122.841 46.8645 124.784 45.4971 124.784Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0215 122.582C46.6541 122.582 46.6541 120.64 48.0215 120.64C49.389 120.64 49.389 122.582 48.0215 122.582Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8309 120.251C43.4634 120.251 43.4634 118.308 44.8309 118.308C46.1632 118.308 46.1632 120.251 44.8309 120.251Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7747 125.075C48.4072 125.075 48.4072 123.133 49.7747 123.133C51.1421 123.133 51.1421 125.075 49.7747 125.075Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0677 126.63C57.0326 126.565 56.9975 126.532 56.9625 126.468C56.717 126.014 56.8222 125.4 57.3482 125.141C57.839 124.914 58.5052 125.011 58.7857 125.496C58.8208 125.561 58.8558 125.593 58.8909 125.659C59.1363 126.112 59.0312 126.727 58.5052 126.986C58.0143 127.212 57.3131 127.083 57.0677 126.63Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8237 125.173C53.4562 125.173 53.4562 123.23 54.8237 123.23C56.1911 123.23 56.1911 125.173 54.8237 125.173Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.2368 53.2294C93.5327 60.0935 93.4625 67.8966 90.0615 74.7283C89.781 75.2786 88.8693 74.7929 89.1498 74.2426C92.4107 67.767 92.4808 60.2554 89.3252 53.7475C89.0797 53.1647 89.9563 52.6466 90.2368 53.2294Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.8861 69.7097C89.255 84.8949 94.0235 99.5617 98.792 113.937C99.0024 114.553 97.9856 114.78 97.7752 114.197C93.0067 99.7561 88.2382 84.992 88.8343 69.7097C88.8693 69.0622 89.9212 69.0622 89.8861 69.7097Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.9562 53.9417C85.4682 51.2867 80.5244 49.506 75.3001 48.5994C74.6339 48.4699 74.9144 47.5633 75.5806 47.6605C80.9101 48.567 85.9241 50.4125 90.4822 53.0999C91.0782 53.456 90.5523 54.2979 89.9562 53.9417Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.5456 48.2433C74.1782 51.9991 70.0057 53.9094 65.9034 53.3913C61.4505 52.8085 57.5235 49.8622 56.1561 45.9121C55.9457 45.3293 56.9625 45.0703 57.1729 45.6531C58.2949 48.9557 61.4505 51.4811 65.0619 52.2582C68.9188 53.0999 73.1964 51.6429 74.5288 47.9843C74.7392 47.4015 75.756 47.6605 75.5456 48.2433Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6119 45.9121C50.6162 46.4625 44.9361 48.3404 39.8871 51.384C39.9221 51.1249 39.9572 50.8659 39.9923 50.6069C46.4788 56.3377 49.5643 64.7236 48.2319 72.9151C48.1267 73.5303 47.1099 73.2712 47.2151 72.6561C48.4774 64.8207 45.4269 56.7586 39.2559 51.2868C39.0105 51.0601 39.0806 50.704 39.3611 50.5098C44.5504 47.3691 50.4409 45.4588 56.6119 44.9084C57.2781 44.876 57.2781 45.8474 56.6119 45.9121Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9264 110.473C33.8212 111.898 33.716 113.323 33.681 114.747C33.6459 116.269 33.2252 118.082 34.7679 119.021C37.2223 120.543 39.9922 121.806 42.692 122.906C48.3371 125.173 54.4029 126.468 60.5739 126.014C61.2401 125.95 61.2401 126.921 60.5739 126.986C53.912 127.471 47.3554 125.95 41.2895 123.392C39.7819 122.745 38.3092 122.065 36.8717 121.32C35.7146 120.704 34.0667 120.09 33.1901 119.118C32.4187 118.244 32.559 117.013 32.594 115.978C32.594 114.132 32.6992 112.319 32.8395 110.473C32.9096 109.826 33.9615 109.826 33.9264 110.473Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.4236 48.2433C74.4236 48.2433 74.4236 48.0815 74.4236 48.1462C74.4236 48.211 74.3885 48.0815 74.3885 48.0815C74.3885 48.0815 74.2833 48.0167 74.2132 47.9844C74.1431 47.9519 74.073 47.9519 74.0028 47.9519C74.073 47.9519 73.8626 47.9844 73.8977 47.9844C73.9678 47.9519 73.8626 48.0167 73.8977 47.9844C73.7223 48.211 73.4418 48.3081 73.1613 48.1462C72.9159 48.0167 72.8107 47.693 72.986 47.4662C73.3367 47.013 73.9327 46.8511 74.4937 47.013C75.0547 47.1748 75.4755 47.6282 75.4404 48.1786C75.4053 48.8586 74.3535 48.8586 74.4236 48.2433Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.7507 45.7826C58.2598 45.3617 57.4183 45.6855 57.278 46.2359C57.1378 46.8511 56.121 46.592 56.2612 45.9769C56.5768 44.6818 58.4702 44.1961 59.487 45.1027C59.9779 45.5236 59.2415 46.2035 58.7507 45.7826Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5475 73.7569C47.6008 75.2787 46.7242 76.9623 46.7593 78.7755C46.7944 80.5562 47.6709 82.2398 48.5475 83.794C50.0201 86.3194 51.633 88.8126 51.3174 91.7589C51.2473 92.2444 50.4058 92.4711 50.3006 91.8884C49.6695 88.8773 48.4423 86.0604 46.6541 83.4702C46.9697 83.3083 47.2502 83.1464 47.5657 82.9846C49.0734 85.2186 51.1421 88.1002 51.4577 90.7876C51.668 92.5034 50.546 94.2847 48.5124 94.0903C47.8462 94.0258 47.8462 93.0544 48.5124 93.119C52.0888 93.4747 49.7396 88.8126 49.1085 87.5822C48.3722 86.1575 47.5657 84.7977 46.6892 83.5026C46.3385 82.9846 47.2502 82.4989 47.6008 83.0169C49.424 85.6719 50.6863 88.5535 51.3525 91.6618C51.0019 91.6941 50.6512 91.7589 50.3357 91.7913C50.7564 88.0031 47.7761 85.1215 46.4087 81.7542C45.1815 78.743 45.9879 75.991 47.706 73.3036C47.9514 72.7208 48.863 73.2064 48.5475 73.7569Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9879 79.4555C46.4437 80.3943 46.8645 81.3333 47.3203 82.2723C47.6008 82.8551 46.6891 83.3408 46.4086 82.758C45.9528 81.819 45.5321 80.88 45.0763 79.9411C44.7958 79.3907 45.7074 78.8727 45.9879 79.4555Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.5826 71.8791C48.828 73.4008 48.4073 74.8254 47.3203 75.991C46.8645 76.4767 46.1282 75.7644 46.584 75.3111C47.3904 74.4369 47.7761 73.3036 47.5658 72.1705C47.4606 71.5229 48.4774 71.2638 48.5826 71.8791Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.5312 19.9128C95.0053 24.6723 94.2689 29.5938 92.6561 34.159C91.3237 37.9148 88.9394 41.6706 85.0124 43.5162C81.3309 45.2321 76.913 44.9084 73.3366 43.16C69.4798 41.2821 66.8501 37.9148 65.2021 34.2885C64.9567 33.7057 65.9735 33.4467 66.219 34.0295C67.7968 37.4939 70.3914 40.7317 74.108 42.4477C77.8948 44.1961 82.523 44.1637 85.9942 41.8001C89.3602 39.5337 91.0783 35.9074 92.1652 32.2811C93.3573 28.2339 94.0235 24.0572 94.4793 19.9128C94.5494 19.2976 95.6013 19.2653 95.5312 19.9128Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.2132 43.3219C73.4418 44.876 73.2315 46.5273 73.4769 48.211C73.5821 48.8261 72.5302 48.8261 72.425 48.211C72.1445 46.333 72.4601 44.5199 73.3016 42.8362C73.5821 42.2535 74.4937 42.7715 74.2132 43.3219Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.512 48.3728C71.8991 50.5745 68.5682 50.4774 66.0086 50.186C62.6777 49.7974 60.8194 48.1137 59.0312 45.6207C58.6455 45.1027 59.5571 44.617 59.9428 45.135C61.3453 47.0453 62.7829 48.6965 65.3775 49.1175C67.5514 49.506 71.1628 49.8298 72.6004 47.8871C72.986 47.3691 73.8977 47.8548 73.512 48.3728Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.6777 35.2598C62.5725 37.2996 62.292 39.307 61.766 41.2821C61.3804 42.7391 60.9245 44.9731 59.8376 46.1387C59.6623 46.3006 59.4169 46.3006 59.2065 46.2035C59.1714 46.2035 59.1364 46.1711 59.1013 46.1711C58.926 46.1064 58.8208 45.9121 58.8559 45.7502C58.8559 45.7178 58.8559 45.6854 58.8559 45.6854C58.8909 45.0703 59.9428 45.0703 59.9077 45.6854C59.8376 45.5883 59.8025 45.4911 59.7324 45.394C59.522 45.4264 59.3117 45.4588 59.1013 45.4588C59.6623 44.876 59.9779 43.5161 60.2233 42.7391C60.4687 41.9944 60.7142 41.2174 60.8895 40.4403C61.3102 38.7242 61.5206 37.0082 61.5907 35.2598C61.6609 34.6123 62.7127 34.6123 62.6777 35.2598Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9735 30.5003C64.7463 31.6983 62.8179 30.986 61.6608 30.047C59.8726 28.6223 59.3116 26.2912 59.522 24.1866C59.6973 22.4059 60.7843 20.4308 62.9231 20.3013C64.7814 20.1718 66.0436 21.6288 66.4644 23.1505C66.6397 23.7658 65.6229 24.0247 65.4476 23.4096C65.0268 21.8878 63.3088 20.5279 61.6959 21.7907C60.6791 22.6002 60.5038 24.0895 60.5388 25.2551C60.5739 26.2912 60.8193 27.3273 61.3803 28.2339C61.9413 29.1404 63.975 31.0183 65.2021 29.8204C65.693 29.3347 66.4644 30.047 65.9735 30.5003Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.2368 26.8092C90.8679 26.4855 91.2886 25.8703 91.1835 25.1903C91.1835 25.0932 91.1484 25.0285 91.1133 24.9314C91.1835 24.9314 91.2185 24.9314 91.2886 24.8989C91.2536 25.0608 91.0783 25.2551 91.0432 25.4494C90.903 25.8703 90.7978 26.2912 91.0432 26.6798C90.7627 26.6473 90.4822 26.615 90.2017 26.5826C90.377 26.3884 90.5173 26.1941 90.6224 25.935C90.6575 25.8379 90.6926 25.7731 90.6926 25.676C90.6575 25.417 90.6926 25.3846 90.7276 25.5142C90.8679 25.5465 90.9731 25.6113 91.1133 25.6436C91.0432 25.6436 90.8679 26.3559 90.8679 26.4531C90.8328 26.6473 90.8328 26.9712 90.938 27.1654C90.8328 27.1006 90.7276 27.0035 90.6224 26.9387C90.7276 26.9712 91.0432 26.097 91.0432 25.9674C91.0783 25.676 91.1484 25.0608 90.8679 24.8342C91.0081 24.8666 91.1133 24.9314 91.2536 24.9637C90.8679 24.9637 90.6926 26.0645 90.6575 26.3236C90.6225 26.5178 90.4822 27.0035 90.7627 26.7769C90.938 26.615 91.0783 26.3236 91.2536 26.1293C91.6743 25.6436 92.4106 26.3236 91.9899 26.8092C91.6743 27.133 91.5341 27.554 91.1133 27.7806C90.7627 27.9748 90.3069 27.9748 89.9913 27.7158C89.3251 27.2301 89.6056 26.1293 89.781 25.4817C89.9563 24.8989 90.5523 23.7981 91.3938 24.0247C92.2003 24.2514 92.2003 25.5465 92.0951 26.1617C91.9548 26.8092 91.4289 28.0396 90.5173 27.9101C89.5706 27.7806 89.7459 26.3559 89.9563 25.7731C90.0965 25.417 90.3069 24.9314 90.6926 24.7371C91.0432 24.6075 91.4289 24.7047 91.6393 24.9961C92.0951 25.7084 91.464 26.7445 90.938 27.2626C90.6926 27.4892 90.2718 27.4244 90.0965 27.1654C89.6056 26.4207 89.781 25.5789 90.1316 24.8018C90.377 24.2514 91.0081 23.6039 91.7094 24.0572C92.3055 24.4781 92.3054 25.3846 92.1301 25.9674C91.9198 26.6798 91.4289 27.2626 90.7276 27.5863C90.2017 27.9425 89.6407 27.1006 90.2368 26.8092Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.913 25.0284C77.1584 24.737 77.3338 24.4133 77.4039 24.0896C77.4039 24.0572 77.5091 23.5068 77.474 23.5068C77.6143 23.5068 77.4389 23.6687 77.4039 23.7334C77.2636 24.0248 77.1234 24.381 77.0533 24.7047C77.0182 24.8342 76.9831 24.9638 76.9481 25.1256C76.913 25.2552 76.913 25.3523 76.913 25.4818C76.913 25.5789 76.8779 25.5789 76.7728 25.4494C76.6325 25.4818 76.4923 25.4818 76.352 25.5141C76.9831 25.0932 77.1234 24.5752 77.2286 23.8953C77.2286 23.8305 77.2286 23.7982 77.2286 23.7334C77.2636 23.8305 77.3338 23.9276 77.3688 24.0572C77.3688 24.1867 77.1584 24.4457 77.1234 24.5752C76.9831 24.9314 76.9481 25.3846 77.0883 25.7408C77.0182 25.6437 76.913 25.5466 76.8429 25.4494C76.8779 25.4818 77.2987 24.9313 77.3338 24.8666C77.474 24.6399 77.5792 24.381 77.5792 24.0896C77.5792 23.8629 77.6143 23.2801 77.1935 23.4744C76.9481 23.6039 76.8078 24.0896 76.7026 24.3162C76.5974 24.6076 76.5273 24.8666 76.4923 25.158C76.4572 25.3846 76.2819 25.7084 76.6325 25.6112C77.2286 25.4494 77.474 24.6076 77.5441 24.1219C77.6493 23.5068 78.6661 23.7658 78.5609 24.381C78.3856 25.3523 77.6143 26.6797 76.3871 26.615C74.9846 26.5502 75.4404 24.8342 75.7209 24.0248C76.0014 23.183 76.9831 21.7584 78.1051 22.6002C79.0168 23.2801 78.7012 24.7695 78.1051 25.5466C77.8246 25.9026 77.4039 26.3236 76.913 26.3883C76.2819 26.4531 76.0364 25.9998 75.9663 25.4818C75.8962 24.6724 76.3169 22.6649 77.5792 22.8592C78.7713 23.0211 78.2454 24.8018 77.8246 25.3846C77.5792 25.7408 77.1234 26.3236 76.5974 26.356C76.1066 26.356 75.8261 25.9026 75.8261 25.5141C75.791 24.6399 76.3871 22.244 77.7194 22.4383C79.3674 22.6649 78.1402 25.0609 77.6143 25.7084C77.2286 26.194 76.4923 25.5141 76.913 25.0284Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.45 24.4133C86.5201 27.0035 86.4149 29.6261 86.0293 32.2163C85.8539 33.3819 85.3981 34.159 83.9956 34.0295C82.2425 33.8676 81.8919 33.0905 82.3828 31.6983C83.2593 29.1405 84.3813 26.6474 85.3981 24.1219C85.6436 23.5391 86.6604 23.7981 86.4149 24.3809C85.889 25.7408 85.328 27.1007 84.8021 28.4605C84.5216 29.1405 84.2761 29.8204 83.9956 30.5003C83.8554 30.8564 83.0489 32.2163 83.1892 32.5402C83.8203 34.0618 84.9423 32.022 85.1176 31.3098C85.328 30.5327 85.2929 29.6261 85.3631 28.8166C85.4683 27.3597 85.4683 25.9027 85.4332 24.4457C85.3631 23.7981 86.4149 23.7981 86.45 24.4133Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.0643 26.3884C85.9942 28.6548 85.8189 30.9535 84.5216 32.9286C84.206 33.4143 83.4346 33.0905 83.5749 32.5401C84.0307 30.5974 84.3813 28.6548 84.5566 26.6798C84.9073 26.7121 85.2579 26.7769 85.5735 26.8092C85.2579 28.8166 84.6969 30.7593 83.9255 32.6696C83.6801 33.2524 82.6633 32.9933 82.9087 32.4105C83.7151 30.5003 84.2761 28.5576 84.5566 26.5502C84.6268 25.9998 85.6436 26.1293 85.5735 26.6798C85.3981 28.7519 85.0475 30.7917 84.5566 32.7991C84.2411 32.6696 83.9255 32.5401 83.61 32.4105C84.8371 30.565 84.9423 28.4605 85.0125 26.3559C85.0125 25.7731 86.0643 25.7731 86.0643 26.3884Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.621 21.8878C91.7445 21.7583 90.8679 21.6612 89.9914 21.4993C89.4654 21.4021 88.9395 21.1432 88.9395 20.5604C88.9395 19.2652 91.0432 19.0709 92.025 19.2652C92.9366 19.4919 94.5144 20.6251 93.3574 21.5317C92.9717 21.8231 92.4457 21.7907 92.06 21.4993C91.8497 21.3374 91.7445 21.1432 91.5692 20.9812C91.1835 20.6575 90.7978 20.7222 90.3069 20.7546C89.6758 20.8193 89.6407 19.9776 90.1667 19.8156C91.0432 19.5566 91.8847 19.7509 92.586 20.3013C92.9015 20.5604 92.6561 21.1755 92.2003 21.1432C91.6744 21.0784 91.1484 21.046 90.6225 20.9812C89.9563 20.9165 89.9563 19.9451 90.6225 20.0099C91.1484 20.0747 91.6744 20.107 92.2003 20.1718C92.06 20.4632 91.9549 20.7222 91.8146 21.0136C91.3939 20.6898 90.938 20.6251 90.4121 20.787C90.377 20.4632 90.3069 20.1394 90.2719 19.848C90.8679 19.7833 91.499 19.7833 91.9899 20.107C92.2003 20.2365 92.3405 20.4308 92.4808 20.5927C92.5509 20.6898 92.8314 20.8841 92.4808 20.6251C92.2704 20.4632 92.1302 20.3661 91.8146 20.269C91.464 20.1718 91.0783 20.1394 90.7277 20.2365C90.5874 20.269 90.2017 20.3337 90.1316 20.4956C90.0615 20.6251 90.1667 20.5927 90.377 20.6251C91.2185 20.7546 92.025 20.8841 92.8665 20.9812C93.5677 21.046 93.2872 21.9849 92.621 21.8878Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.279 19.5891C79.1921 20.0423 78.035 20.4956 76.8429 20.1719C76.0715 19.9776 75.0197 19.2329 75.6508 18.4235C75.9313 18.0673 76.4572 17.9054 76.878 17.7759C77.439 17.5816 78.035 17.355 78.6311 17.2902C79.6129 17.1931 80.5595 17.6464 80.5946 18.6177C80.5946 18.812 80.4193 19.071 80.2089 19.071C79.683 19.1358 79.2622 19.1034 78.7714 18.9738C78.2454 18.8444 77.439 18.5853 77.1585 19.1681C77.0182 18.9091 76.8429 18.6824 76.7027 18.4235C77.474 18.4558 78.2104 18.391 78.9817 18.1968C78.9817 18.5206 78.9817 18.812 78.9817 19.1358C78.3857 19.0386 77.7896 19.1358 77.2286 19.3624C77.2637 19.1034 77.2987 18.8444 77.3338 18.5853C77.474 18.6177 77.6143 18.6501 77.7545 18.7149C78.4207 18.6501 78.4207 19.6214 77.7545 19.6862C77.2987 19.7186 76.9481 19.5891 76.5975 19.2977C76.3871 19.1034 76.3871 18.6501 76.7027 18.5206C77.5442 18.1644 78.3506 18.0673 79.2622 18.1968C79.7882 18.2616 79.718 19.0063 79.2622 19.1358C78.4207 19.33 77.5792 19.4272 76.7027 19.3948C76.2819 19.3948 76.0715 19.0063 76.2469 18.6501C76.4923 18.1644 76.9832 17.9054 77.5792 17.8082C78.3857 17.7111 79.157 18.1644 79.9635 18.0673C79.8232 18.2292 79.718 18.391 79.5778 18.5206C79.5778 17.8407 78.3506 18.2292 78.035 18.3263C77.7896 18.391 76.4923 18.6824 76.8079 19.0386C77.0533 19.2977 77.8247 19.2329 78.1402 19.1681C78.7012 19.071 79.2272 18.8767 79.7531 18.6501C80.3492 18.4882 80.9102 19.33 80.279 19.5891Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.8904 33.6086C83.645 33.5438 83.3645 33.479 83.1191 33.4467C82.8386 33.3819 82.6633 33.0905 82.7685 32.8639C82.8386 32.6048 83.1541 32.4754 83.3996 32.5401C83.645 32.6048 83.9255 32.6696 84.1709 32.702C84.4514 32.7668 84.6268 33.0582 84.5216 33.2848C84.4514 33.5438 84.1709 33.6733 83.8904 33.6086Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.0283 22.6325C64.8515 23.1829 66.0787 24.8018 65.9735 26.5826C65.9385 27.0035 65.2372 27.2949 64.9918 26.8416C64.536 25.9351 63.3438 26.8093 64.1152 27.3596C64.6411 27.7482 64.1152 28.59 63.5893 28.2015C62.7828 27.6187 62.4673 26.4531 63.3438 25.7732C64.1853 25.1256 65.4826 25.4818 65.9034 26.356C65.5878 26.4531 65.2372 26.5179 64.9216 26.615C65.0268 25.2551 64.1853 24.0248 62.7478 23.6039C62.1167 23.3772 62.3621 22.4383 63.0283 22.6325Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.6364 21.0784C98.231 21.6289 101.211 20.8193 103.21 19.1357C105.103 17.5493 107.417 14.1819 105.805 11.2356C104.297 8.48348 100.475 8.12732 100.124 8.12732C100.756 7.47977 101.948 6.05514 101.632 4.56578C101.001 1.65178 95.0053 1.0366 94.3741 0.971845C88.4486 0.453806 83.8203 4.08011 82.3126 5.37522C77.9649 3.59445 74.2833 3.40018 72.2146 3.43255C70.7771 3.46493 60.3986 3.75633 58.2948 9.00152C57.7338 10.4262 57.9442 11.786 58.1546 12.6278C57.9442 12.5631 53.6666 11.3004 50.4408 13.923C47.7761 16.0923 47.0398 19.9451 48.8981 22.7297C50.8265 25.6437 54.5081 25.9351 54.9288 25.9674C52.5446 27.5215 51.668 30.3061 52.6848 32.5725C53.7367 34.9037 56.4015 35.8427 58.4351 35.8102C60.1882 35.7779 61.4154 34.9685 62.3621 34.3857C64.0451 33.3172 65.9735 31.3745 65.4476 30.5003C65.0268 29.788 63.5191 30.5975 61.9413 29.7233C60.2583 28.8166 59.5922 26.6798 59.6973 25.0609C59.8376 22.8268 61.5206 20.1394 63.3438 20.269C64.4308 20.3337 65.2372 21.4021 65.5878 21.9526C68.6383 22.4059 70.4966 21.8231 71.6186 21.1755C74.0028 19.8157 74.073 17.7435 76.5273 15.7361C78.4558 14.1496 80.6998 13.5344 82.2776 13.2754C83.9956 13.8905 86.4851 14.959 89.1498 16.7722C92.5158 19.0709 93.182 20.5604 95.6364 21.0784Z",
    fill: "#dddddd",
    stroke: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1306 36.0369C68.4279 39.3394 69.8304 42.642 72.4952 45.2321C72.2147 45.2645 71.9342 45.2969 71.6537 45.3293C72.0394 44.7788 72.951 43.6457 72.6004 43.2571C72.3549 42.9981 71.6887 42.8361 71.3732 42.642C70.2161 41.8649 69.4097 40.764 68.2877 39.9546C68.5682 39.7603 68.8487 39.5661 69.1292 39.3718C70.2161 41.0878 71.4433 42.7067 72.8107 44.2608C72.5302 44.3256 72.2147 44.3903 71.9342 44.4874C71.8641 44.0989 71.829 43.7103 71.7589 43.3218C72.0744 43.1923 72.39 43.0629 72.7056 42.9333C72.8107 43.3543 72.9159 43.7428 73.0562 44.1637C72.7056 44.2608 72.39 44.3256 72.0394 44.4227C71.9342 43.9046 71.829 43.4189 71.6537 42.9009C71.4433 42.3181 72.4601 42.0592 72.6705 42.642C72.8458 43.16 72.951 43.6457 73.0562 44.1637C73.1614 44.7788 72.2147 45.0379 72.0394 44.4227C71.9342 44.0017 71.829 43.6132 71.6887 43.1923C71.5485 42.6743 72.39 42.2858 72.6354 42.8038C72.951 43.4837 73.0211 43.9694 72.9159 44.7141C72.8458 45.0702 72.2848 45.1998 72.0394 44.9407C70.6018 43.3543 69.3396 41.6706 68.1825 39.8575C67.8669 39.3394 68.5682 38.9509 69.024 39.2747C69.7603 39.8251 70.3914 40.4726 71.0576 41.1202C71.4433 41.4764 71.8641 41.8649 72.3549 42.1239C72.4251 42.1562 73.2666 42.3829 73.4419 42.5772C74.3184 43.4837 73.1263 45.0055 72.5653 45.8473C72.39 46.1063 71.9692 46.1711 71.7238 45.9444C68.9188 43.2247 67.4812 39.7927 66.1138 36.3283C65.9034 35.7131 66.9202 35.4541 67.1306 36.0369Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3217 59.8345C43.9543 59.8345 43.9543 57.8918 45.3217 57.8918C46.6541 57.8918 46.6541 59.8345 45.3217 59.8345Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7622 57.1795C41.3948 57.1795 41.3948 55.2369 42.7622 55.2369C44.0946 55.2369 44.0946 57.1795 42.7622 57.1795Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9571 54.8807C38.5897 54.8807 38.5897 52.938 39.9571 52.938C41.2895 52.938 41.3246 54.8807 39.9571 54.8807Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5657 66.9576C46.1983 66.9576 46.1983 65.015 47.5657 65.015C48.8981 65.015 48.8981 66.9576 47.5657 66.9576Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6373 64.7883C44.2698 64.7883 44.2698 62.8456 45.6373 62.8456C47.0047 62.8456 47.0047 64.7883 45.6373 64.7883Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7622 60.0611C42.7972 60.0611 42.8323 60.0611 42.8674 60.0611C43.4284 60.0611 43.9543 60.5144 43.9192 61.0324C43.8842 61.5505 43.4634 62.0038 42.8674 62.0038C42.8323 62.0038 42.7972 62.0038 42.7622 62.0038C42.2012 62.0038 41.6752 61.5505 41.7103 61.0324C41.7103 60.5144 42.1661 60.0611 42.7622 60.0611Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.413 59.964C39.0455 59.964 39.0455 58.0214 40.413 58.0214C41.7453 58.0214 41.7453 59.964 40.413 59.964Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8183 57.6651C36.4509 57.6651 36.4509 55.7225 37.8183 55.7225C39.1857 55.7225 39.1857 57.6651 37.8183 57.6651Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4423 94.4138C47.0748 94.4138 47.0748 92.4711 48.4423 92.4711C49.8097 92.4711 49.8097 94.4138 48.4423 94.4138Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5321 92.5357C44.1647 92.5357 44.1647 90.5933 45.5321 90.5933C46.8995 90.5933 46.8995 92.5357 45.5321 92.5357Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2319 90.1723C46.8644 90.1723 46.8644 88.2297 48.2319 88.2297C49.5642 88.2297 49.5642 90.1723 48.2319 90.1723Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0061 87.6145C44.9711 87.5822 44.936 87.5498 44.9009 87.5174C44.5153 87.1612 44.4802 86.5137 44.9009 86.1575C45.3217 85.8014 45.9879 85.769 46.3736 86.1575C46.4086 86.19 46.4437 86.2223 46.4788 86.2547C46.8644 86.6109 46.8995 87.2584 46.4788 87.6145C46.0931 87.9707 45.4269 88.0031 45.0061 87.6145Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9725 85.2187C41.605 85.2187 41.605 83.276 42.9725 83.276C44.3399 83.276 44.3399 85.2187 42.9725 85.2187Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6373 83.1789C44.2698 83.1789 44.2698 81.2362 45.6373 81.2362C47.0047 81.2362 47.0047 83.1789 45.6373 83.1789Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6373 78.2251C44.2698 78.2251 44.2698 76.2824 45.6373 76.2824C47.0047 76.2824 47.0047 78.2251 45.6373 78.2251Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2362 79.9087C42.2362 79.8763 42.2362 79.8439 42.2362 79.8115C42.2362 79.2935 42.7271 78.8079 43.2881 78.8402C43.8491 78.8726 44.34 79.2611 44.34 79.8115C44.34 79.8439 44.34 79.8763 44.34 79.9087C44.34 80.4267 43.8491 80.9124 43.2881 80.88C42.7271 80.88 42.2362 80.4591 42.2362 79.9087Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.2728 78.4194C38.9053 78.4194 38.9053 76.4767 40.2728 76.4767C41.6402 76.4767 41.6402 78.4194 40.2728 78.4194Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8183 80.7829C36.4509 80.7829 36.4509 78.8402 37.8183 78.8402C39.1857 78.8402 39.1857 80.7829 37.8183 80.7829Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1675 83.0493C38.8001 83.0493 38.8001 81.1066 40.1675 81.1066C41.535 81.1066 41.535 83.0493 40.1675 83.0493Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.608 85.7367C36.2405 85.7367 36.2405 83.794 37.608 83.794C38.9754 83.794 38.9754 85.7367 37.608 85.7367Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6416 87.6145C39.6065 87.5822 39.5714 87.5498 39.5364 87.5174C39.1507 87.1612 39.1156 86.5137 39.5364 86.1575C39.9571 85.8014 40.6233 85.769 41.009 86.1575C41.0441 86.19 41.0791 86.2223 41.1142 86.2547C41.4999 86.6109 41.5349 87.2584 41.1142 87.6145C40.7285 87.9707 40.0623 88.0031 39.6416 87.6145Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.814 89.0067C43.814 89.0392 43.814 89.0715 43.814 89.1039C43.814 89.622 43.3231 90.1076 42.7621 90.0752C42.2011 90.0429 41.7102 89.6543 41.7102 89.1039C41.7102 89.0715 41.7102 89.0392 41.7102 89.0067C41.7102 88.4887 42.2011 88.0031 42.7621 88.0354C43.3231 88.0678 43.814 88.4564 43.814 89.0067Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1674 90.8199C40.2025 90.8199 40.2376 90.8199 40.2726 90.8199C40.8336 90.8199 41.3596 91.2733 41.3245 91.7913C41.2894 92.3089 40.8687 92.7623 40.2726 92.7623C40.2376 92.7623 40.2025 92.7623 40.1674 92.7623C39.6064 92.7623 39.0805 92.3089 39.1156 91.7913C39.1506 91.2733 39.5714 90.8199 40.1674 90.8199Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0777 95.0294C41.7103 95.0294 41.7103 93.0867 43.0777 93.0867C44.4451 93.0867 44.4451 95.0294 43.0777 95.0294Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6233 97.1011C39.2559 97.1011 39.2559 95.1584 40.6233 95.1584C41.9908 95.1584 41.9908 97.1011 40.6233 97.1011Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0637 94.705C36.6963 94.705 36.6963 92.7623 38.0637 92.7623C39.3961 92.7623 39.3961 94.705 38.0637 94.705Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6094 96.7776C35.5744 96.7776 35.5393 96.7776 35.5042 96.7776C34.9432 96.7776 34.4173 96.3242 34.4524 95.8063C34.4874 95.2884 34.9082 94.835 35.5042 94.835C35.5393 94.835 35.5744 94.835 35.6094 94.835C36.1704 94.835 36.6964 95.2884 36.6613 95.8063C36.6262 96.3242 36.1704 96.7776 35.6094 96.7776Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0148 95.1261C31.6474 95.1261 31.6474 93.1835 33.0148 93.1835C34.3823 93.1835 34.3823 95.1261 33.0148 95.1261Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8956 94.9317C26.5282 94.9317 26.5282 92.989 27.8956 92.989C29.228 92.989 29.228 94.9317 27.8956 94.9317Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7751 92.2444C23.4077 92.2444 23.4077 90.3019 24.7751 90.3019C26.1075 90.3019 26.1075 92.2444 24.7751 92.2444Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1973 90.2696C21.8299 90.2696 21.8299 88.3269 23.1973 88.3269C24.5648 88.3269 24.5648 90.2696 23.1973 90.2696Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1045 92.5357C28.7371 92.5357 28.7371 90.5933 30.1045 90.5933C31.472 90.5933 31.472 92.5357 30.1045 92.5357Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6502 90.0752C26.2828 90.0752 26.2828 88.1326 27.6502 88.1326C29.0176 88.1326 29.0176 90.0752 27.6502 90.0752Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3486 89.6543C30.9811 89.6543 30.9811 87.7117 32.3486 87.7117C33.716 87.7117 33.716 89.6543 32.3486 89.6543Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3639 92.3421C33.9965 92.3421 33.9965 90.399 35.3639 90.399C36.7314 90.399 36.7314 92.3421 35.3639 92.3421Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6079 88.0354C37.678 88.0354 37.7482 88.0354 37.8183 88.0354C38.3793 88.0354 38.9052 88.4887 38.8702 89.0067C38.8351 89.5248 38.4144 89.9781 37.8183 89.9781C37.7482 89.9781 37.678 89.9781 37.6079 89.9781C37.0469 89.9781 36.521 89.5248 36.556 89.0067C36.5911 88.4887 37.0119 88.0354 37.6079 88.0354Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.4692 87.8088C34.1017 87.8088 34.1017 85.8663 35.4692 85.8663C36.8366 85.8663 36.8366 87.8088 35.4692 87.8088Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9614 84.3444C33.9614 84.3768 33.9614 84.4092 33.9614 84.4415C33.9614 84.9596 33.4706 85.4453 32.9096 85.4129C32.3486 85.3805 31.8577 84.992 31.8577 84.4415C31.8577 84.4092 31.8577 84.3768 31.8577 84.3444C31.8577 83.8264 32.3486 83.3407 32.9096 83.3731C33.4706 83.4055 33.9614 83.8264 33.9614 84.3444Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2449 87.4851C28.8774 87.4851 28.8774 85.5424 30.2449 85.5424C31.5772 85.5424 31.5772 87.4851 30.2449 87.4851Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6502 85.3158C26.2828 85.3158 26.2828 83.3731 27.6502 83.3731C29.0176 83.3731 29.0176 85.3158 27.6502 85.3158Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6517 87.7117C24.2842 87.7117 24.2842 85.769 25.6517 85.769C27.0191 85.769 27.0191 87.7117 25.6517 87.7117Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1973 85.5424C21.8299 85.5424 21.8299 83.5997 23.1973 83.5997C24.5648 83.5997 24.5648 85.5424 23.1973 85.5424Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0738 81.9485V81.9161C24.0738 82.0133 24.0388 82.078 24.0388 82.1751V82.1427C24.0388 82.2399 24.0738 82.3047 24.0738 82.4018V82.3695C24.1089 82.4341 24.1439 82.5313 24.179 82.5961C24.2842 82.6932 24.3543 82.7903 24.4595 82.855C24.2491 82.7579 24.0388 82.4989 23.9686 82.2722C23.8985 82.0456 23.9336 81.7219 24.0738 81.5276C24.2141 81.3333 24.4244 81.1391 24.7049 81.0743C24.9854 81.0096 25.2309 81.0419 25.5114 81.1714C25.7568 81.2685 25.9321 81.4953 26.0373 81.7219C26.1425 81.9809 26.1425 82.2075 26.1074 82.4665C26.0023 82.9522 25.3361 83.3083 24.8101 83.1464C24.2491 82.9522 23.9686 82.4665 24.0738 81.9485Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4076 80.6857C23.3726 80.6857 23.3375 80.6857 23.3025 80.6857C22.7415 80.6857 22.2155 80.2324 22.2506 79.7144C22.2856 79.1963 22.7064 78.743 23.3025 78.743C23.3375 78.743 23.3726 78.743 23.4076 78.743C23.9686 78.743 24.4946 79.1963 24.4595 79.7144C24.4595 80.2324 24.0037 80.6857 23.4076 80.6857Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1045 83.0493C28.7371 83.0493 28.7371 81.1066 30.1045 81.1066C31.472 81.1066 31.472 83.0493 30.1045 83.0493Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5983 80.1353C26.5983 80.103 26.5983 80.0705 26.5983 80.0382C26.5983 79.5202 27.0892 79.0345 27.6502 79.0668C28.2112 79.0992 28.702 79.4877 28.702 80.0382C28.702 80.0705 28.702 80.103 28.702 80.1353C28.702 80.6533 28.2112 81.139 27.6502 81.1066C27.0892 81.0743 26.5983 80.6858 26.5983 80.1353Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2492 77.3509C24.2492 77.3184 24.2492 77.2861 24.2492 77.2537C24.2141 77.027 24.3894 76.7356 24.5647 76.5738C24.74 76.4119 25.0556 76.2824 25.301 76.2824C25.5815 76.2824 25.862 76.3795 26.0373 76.5738C26.2477 76.7681 26.3178 76.9947 26.3529 77.2537C26.3529 77.2861 26.3529 77.3184 26.3529 77.3509C26.388 77.5775 26.2127 77.8689 26.0373 78.0308C25.862 78.1926 25.5465 78.3222 25.301 78.3222C25.0205 78.3222 24.74 78.2251 24.5647 78.0308C24.3543 77.8365 24.2842 77.6098 24.2492 77.3509Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5575 81.7866C34.5575 81.7542 34.5575 81.7219 34.5575 81.6894C34.5575 81.1714 35.0484 80.6857 35.6094 80.7181C36.1704 80.7505 36.6613 81.1391 36.6613 81.6894C36.6613 81.7219 36.6613 81.7542 36.6613 81.7866C36.6613 82.3047 36.1704 82.7903 35.6094 82.7579C35.0133 82.7255 34.5575 82.337 34.5575 81.7866Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3653 81.0096C31.9979 81.0096 31.9979 79.0669 33.3653 79.0669C34.6977 79.0669 34.7328 81.0096 33.3653 81.0096Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.35 78.4194C28.9825 78.4194 28.9825 76.4767 30.35 76.4767C31.6823 76.4767 31.7174 78.4194 30.35 78.4194Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4399 76.1528C26.0724 76.1528 26.0724 74.2101 27.4399 74.2101C28.8073 74.2101 28.8073 76.1528 27.4399 76.1528Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6165 72.1057C25.6516 72.138 25.6867 72.1705 25.7217 72.2028C26.1074 72.559 26.1425 73.2065 25.7217 73.5627C25.301 73.9189 24.6348 73.9512 24.2491 73.5627C24.214 73.5303 24.179 73.4979 24.1439 73.4656C23.7582 73.1094 23.7232 72.4619 24.1439 72.1057C24.5296 71.7495 25.1958 71.7172 25.6165 72.1057Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9081 78.3222C33.5407 78.3222 33.5407 76.3795 34.9081 76.3795C36.2756 76.3795 36.2756 78.3222 34.9081 78.3222Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.155 76.3472C31.7876 76.3472 31.7876 74.4045 33.155 74.4045C34.4874 74.4045 34.4874 76.3472 33.155 76.3472Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4553 73.9836C29.0878 73.9836 29.0878 72.0409 30.4553 72.0409C31.8227 72.0409 31.8227 73.9836 30.4553 73.9836Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0008 71.2962C26.6334 71.2962 26.6334 69.3536 28.0008 69.3536C29.3682 69.3536 29.3682 71.2962 28.0008 71.2962Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.862 69.5478C24.4946 69.5478 24.4946 67.6052 25.862 67.6052C27.2294 67.6052 27.2294 69.5478 25.862 69.5478Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8957 66.6662C27.8606 66.6662 27.8256 66.6662 27.7905 66.6662C27.2295 66.6662 26.7036 66.2129 26.7386 65.6948C26.7737 65.1768 27.1944 64.7235 27.7905 64.7235C27.8256 64.7235 27.8606 64.7235 27.8957 64.7235C28.4567 64.7235 28.9826 65.1768 28.9476 65.6948C28.9125 66.2129 28.4917 66.6662 27.8957 66.6662Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.35 69.224C28.9825 69.224 28.9825 67.2814 30.35 67.2814C31.6823 67.2814 31.7174 69.224 30.35 69.224Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7525 70.6487C31.7525 70.6163 31.7525 70.5839 31.7525 70.5515C31.7525 70.0335 32.2433 69.5479 32.8043 69.5802C33.3653 69.6126 33.8562 70.0011 33.8562 70.5515C33.8562 70.5839 33.8562 70.6163 33.8562 70.6487C33.8562 71.1667 33.3653 71.6524 32.8043 71.62C32.2433 71.5877 31.7525 71.1667 31.7525 70.6487Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6094 73.8864C34.2419 73.8864 34.2419 71.9438 35.6094 71.9438C36.9417 71.9438 36.9417 73.8864 35.6094 73.8864Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0637 76.0557C36.6963 76.0557 36.6963 74.113 38.0637 74.113C39.3961 74.113 39.3961 76.0557 38.0637 76.0557Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.7088 75.4405C43.6737 75.4729 43.6387 75.5053 43.6036 75.5376C43.2179 75.8938 42.5167 75.9262 42.131 75.5376C41.7453 75.1491 41.7102 74.534 42.131 74.1778C42.166 74.1454 42.2011 74.1131 42.2362 74.0806C42.6219 73.7245 43.3231 73.6921 43.7088 74.0806C44.0945 74.4692 44.1295 75.052 43.7088 75.4405Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6233 73.8864C39.2559 73.8864 39.2559 71.9438 40.6233 71.9438C41.9908 71.9438 41.9908 73.8864 40.6233 73.8864Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.765 70.2277C38.765 70.2601 38.765 70.2925 38.765 70.3249C38.765 70.8429 38.2741 71.3286 37.7131 71.2962C37.1521 71.2639 36.6613 70.8753 36.6613 70.3249C36.6613 70.2925 36.6613 70.2601 36.6613 70.2277C36.6613 69.7097 37.1521 69.2241 37.7131 69.2564C38.2741 69.2888 38.765 69.6773 38.765 70.2277Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3639 69.1269C33.9965 69.1269 33.9965 67.1842 35.3639 67.1842C36.7314 67.1842 36.7314 69.1269 35.3639 69.1269Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8577 66.213C31.8577 66.1805 31.8577 66.1482 31.8577 66.1158C31.8577 65.5977 32.3486 65.112 32.9096 65.1445C33.4706 65.1768 33.9614 65.5654 33.9614 66.1158C33.9614 66.1482 33.9614 66.1805 33.9614 66.213C33.9614 66.731 33.4706 67.2166 32.9096 67.1843C32.3486 67.1518 31.8577 66.731 31.8577 66.213Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9994 64.4969C28.632 64.4969 28.632 62.5543 29.9994 62.5543C31.3669 62.5543 31.3669 64.4969 29.9994 64.4969Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8044 62.4248C31.4369 62.4248 31.4369 60.4821 32.8044 60.4821C34.1718 60.4821 34.1718 62.4248 32.8044 62.4248Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0484 59.7373C35.0133 59.7373 34.9783 59.7373 34.9432 59.7373C34.3822 59.7373 33.8563 59.284 33.8913 58.766C33.9264 58.2479 34.3471 57.7947 34.9432 57.7947C34.9783 57.7947 35.0133 57.7947 35.0484 57.7947C35.6094 57.7947 36.1353 58.2479 36.1003 58.766C36.0652 59.284 35.6094 59.7373 35.0484 59.7373Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.155 57.8918C31.7876 57.8918 31.7876 55.9492 33.155 55.9492C34.4874 55.9492 34.4874 57.8918 33.155 57.8918Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8183 62.4248C36.4509 62.4248 36.4509 60.4821 37.8183 60.4821C39.1857 60.4821 39.1857 62.4248 37.8183 62.4248Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.925 64.076C34.5575 64.076 34.5575 62.1334 35.925 62.1334C37.2924 62.1334 37.2924 64.076 35.925 64.076Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5182 64.6912C39.1507 64.6912 39.1507 62.7485 40.5182 62.7485C41.8505 62.7485 41.8505 64.6912 40.5182 64.6912Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3793 66.5691C37.0119 66.5691 37.0119 64.6264 38.3793 64.6264C39.7468 64.6264 39.7468 66.5691 38.3793 66.5691Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.6219 66.7633C41.2544 66.7633 41.2544 64.8207 42.6219 64.8207C43.9893 64.8207 43.9893 66.7633 42.6219 66.7633Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7286 69.1269C39.3611 69.1269 39.3611 67.1842 40.7286 67.1842C42.096 67.1842 42.096 69.1269 40.7286 69.1269Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5335 71.62C42.1661 71.62 42.1661 69.6773 43.5335 69.6773C44.8659 69.6773 44.9009 71.62 43.5335 71.62Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2165 69.645C43.8491 69.645 43.8491 67.7023 45.2165 67.7023C46.5489 67.7023 46.5489 69.645 45.2165 69.645Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5321 71.62C45.5671 71.62 45.6022 71.62 45.6373 71.62C46.1983 71.62 46.7242 72.0732 46.6891 72.5913C46.6541 73.1093 46.2333 73.5627 45.6373 73.5627C45.6022 73.5627 45.5671 73.5627 45.5321 73.5627C44.9711 73.5627 44.4451 73.1093 44.4802 72.5913C44.5153 72.0732 44.936 71.62 45.5321 71.62Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0916 72.138C46.7242 72.138 46.7242 70.1953 48.0916 70.1953C49.459 70.1953 49.459 72.138 48.0916 72.138Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8168 51.4811C23.8634 59.5431 20.8831 77.6746 23.0219 92.8923C23.092 93.507 22.0402 93.507 21.97 92.8923C19.7611 77.3509 22.9869 58.8955 39.2558 50.6392C39.887 50.3478 40.4129 51.1573 39.8168 51.4811Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4773 72.5589C47.9865 73.7569 47.4956 74.9873 47.0047 76.1852C46.5489 77.3508 45.7074 78.7755 45.7775 80.0381C45.8476 81.2685 46.7943 82.5636 47.3203 83.6645C47.7761 84.6034 48.1968 85.5747 48.6176 86.546C49.0734 87.647 49.5292 88.7801 49.9149 89.9134C50.1603 90.6904 50.546 91.5646 50.2655 92.3743C49.7746 93.8313 47.5306 94.5437 46.1632 95.0939C38.5897 98.1046 29.5787 97.3278 22.7415 93.1512C22.1805 92.7946 22.7064 91.9532 23.2674 92.3089C29.9643 96.3887 38.8001 97.1333 46.1281 94.058C46.7943 93.7991 48.0215 93.4102 48.5124 92.8922C49.1435 92.2121 49.0734 90.7228 48.7929 89.9134C48.6176 89.4277 48.4423 88.9744 48.267 88.4887C47.4956 86.4489 46.584 84.5063 45.6022 82.5636C44.936 81.2037 44.5153 80.0706 45.0061 78.5812C45.6723 76.4766 46.6541 74.4045 47.4956 72.3322C47.706 71.7171 48.7228 71.9437 48.4773 72.5589Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.5705 119.798C90.6575 119.442 93.4274 118.988 94.1637 118.082C94.7598 116.56 94.304 115.848 92.7612 115.88C92.2002 115.848 91.6392 115.88 91.0782 116.01C90.4822 116.107 89.8861 116.301 89.3251 116.496C86.6603 117.37 84.241 118.308 81.401 118.535C75.8962 118.924 70.4965 117.305 65.693 114.974C56.717 110.635 48.4773 104.192 43.814 95.8063C43.5686 95.3851 44.2698 95.0294 44.4802 95.4496C47.215 100.339 51.142 104.516 55.7352 108.012C60.7141 111.801 66.5345 115.233 72.7405 116.917C76.1065 117.823 79.718 118.211 83.2242 117.629C86.2747 117.143 89.1147 115.265 92.2002 115.201C93.6728 115.168 95.7766 115.654 95.461 117.435C95.1104 119.539 91.499 120.025 89.816 120.575C89.29 120.64 89.0797 119.96 89.5705 119.798Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.0965 119.96C93.4976 121.773 98.4414 121.611 102.228 121.417C104.227 121.32 109.626 119.572 110.959 121.967C113.343 126.273 96.6882 125.496 94.865 125.238C94.3741 125.173 94.5845 124.461 95.0754 124.525C98.4764 124.946 101.913 124.979 105.279 124.525C106.401 124.363 108.645 124.298 109.591 123.554C110.328 122.356 110.117 121.708 108.995 121.611C108.539 121.547 108.048 121.514 107.593 121.547C106.716 121.579 105.84 121.741 104.963 121.87C102.088 122.291 99.1777 122.194 96.2324 122.065C93.9183 121.935 91.7094 121.708 89.6758 120.608C89.255 120.381 89.6407 119.733 90.0965 119.96Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.353 125.075C103.315 125.173 107.277 125.367 111.204 125.755C112.642 125.885 115.938 126.695 114.605 128.734C114.044 129.609 112.466 129.771 111.485 129.964C109.872 130.256 108.224 130.418 106.576 130.418C102.824 130.45 99.1076 129.835 95.426 129.187C94.9351 129.091 95.1455 128.41 95.6364 128.475C100.755 129.382 106.085 130.223 111.274 129.252C111.66 129.187 112.572 129.155 112.852 128.896C113.448 127.375 113.168 126.598 112.046 126.598C111.66 126.532 111.239 126.5 110.853 126.468C109.626 126.338 108.364 126.273 107.137 126.177C104.542 126.014 101.948 125.885 99.353 125.82C98.8271 125.788 98.8271 125.075 99.353 125.075Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.349 129.9C107.032 129.641 109.591 129.803 110.643 131.26C111.555 132.49 110.152 133.429 108.96 133.656C106.26 134.174 103.105 133.882 100.405 133.558C97.4947 133.203 94.6897 132.522 91.9197 131.583C91.4639 131.421 91.6392 130.709 92.1301 130.871C95.426 132.005 98.827 132.749 102.298 133.008C103.911 133.137 105.489 133.137 107.102 133.073C107.523 133.04 107.943 133.04 108.364 133.008C110.082 132.199 110.328 131.551 109.065 131.098C107.943 130.548 106.751 130.45 105.524 130.644C105.033 130.677 104.823 129.997 105.349 129.9Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.5984 133.137C101.246 133.267 105.98 133.364 106.401 135.436C106.856 137.768 100.861 137.444 99.6335 137.411C91.6042 137.088 84.5566 133.235 77.2987 130.483C69.9356 127.698 61.9764 127.083 54.7185 124.007C47.9163 121.125 40.8688 117.402 35.4341 112.578C29.8592 107.624 26.0373 101.213 24.3543 94.2847C24.2492 93.8313 25.0205 93.6369 25.1257 94.0903C26.4932 99.7238 29.2982 105.034 33.3303 109.437C37.5729 114.067 43.0777 117.305 48.7228 120.284C54.7185 123.457 60.8544 125.659 67.6215 127.05C70.9875 127.73 74.2833 128.573 77.5091 129.771C80.5595 130.903 83.5048 132.231 86.5201 133.429C90.3069 134.919 94.2689 136.213 98.4063 136.57C100.054 136.699 102.649 137.022 104.157 136.376C106.541 135.404 103.736 134.401 102.824 134.206C101.772 133.979 100.685 133.915 99.6335 133.817C99.0725 133.817 99.0725 133.073 99.5984 133.137Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.176 133.947C99.2127 133.979 97.4245 133.332 95.6013 132.651C95.1455 132.49 95.3559 131.778 95.8117 131.94C97.5297 132.587 99.2829 133.203 101.176 133.203C101.702 133.203 101.702 133.947 101.176 133.947Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.611 130.094C106.611 130.126 106.611 130.159 106.611 130.191C106.576 130.385 106.506 130.483 106.33 130.548C105.594 130.807 104.472 130.58 103.736 130.483C102.789 130.385 101.877 130.191 100.966 129.932C100.475 129.803 100.685 129.091 101.176 129.22C101.913 129.414 102.684 129.576 103.455 129.705C104.157 129.803 105.454 130.062 106.12 129.835C106.015 129.964 105.91 130.062 105.84 130.191C105.84 130.159 105.84 130.126 105.84 130.094C105.91 129.641 106.681 129.641 106.611 130.094Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0594 96.7776C37.3976 98.4613 30.35 97.6845 24.2842 94.6083C23.6881 94.317 24.2141 93.4747 24.8101 93.7659C30.6305 96.7131 37.3625 97.4578 43.7789 95.8386C44.4451 95.6764 44.7256 96.6154 44.0594 96.7776Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1997 96.7776C41.3246 98.3314 38.0638 98.3959 34.803 98.0402C31.5071 97.7167 28.071 97.2633 25.1959 95.6441C24.6349 95.3206 25.1608 94.4783 25.7218 94.8027C28.4216 96.3565 31.6824 96.7776 34.803 97.0688C37.8534 97.3601 40.9389 97.3923 43.6387 95.9353C44.2698 95.6441 44.7958 96.4864 44.1997 96.7776Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.049 85.2187C106.681 85.2187 106.681 83.276 108.049 83.276C109.381 83.276 109.381 85.2187 108.049 85.2187Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.541 86.5138C106.541 86.5462 106.541 86.5785 106.541 86.6109C106.541 87.129 106.05 87.6147 105.489 87.5822C104.928 87.5499 104.437 87.1613 104.437 86.6109C104.437 86.5785 104.437 86.5462 104.437 86.5138C104.437 85.9957 104.928 85.5101 105.489 85.5424C106.05 85.5749 106.541 85.9634 106.541 86.5138Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.631 89.4601C103.596 89.4925 103.56 89.5249 103.525 89.5572C103.14 89.9134 102.438 89.9458 102.053 89.5572C101.667 89.1687 101.632 88.5536 102.053 88.1975C102.088 88.165 102.123 88.1327 102.158 88.1003C102.544 87.7441 103.245 87.7118 103.631 88.1003C104.016 88.4888 104.051 89.0716 103.631 89.4601Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.124 92.018C100.089 92.018 100.054 92.018 100.019 92.018C99.4582 92.018 98.9323 91.5647 98.9673 91.0467C99.0024 90.5285 99.4231 90.0753 100.019 90.0753C100.054 90.0753 100.089 90.0753 100.124 90.0753C100.685 90.0753 101.211 90.5285 101.176 91.0467C101.141 91.5647 100.685 92.018 100.124 92.018Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.3208 92.3421C93.9534 92.3421 93.9534 90.399 95.3208 90.399C96.6532 90.399 96.6532 92.3421 95.3208 92.3421Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.0908 89.9457C96.7233 89.9457 96.7233 88.0031 98.0908 88.0031C99.4582 88.0031 99.4582 89.9457 98.0908 89.9457Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.44 87.6794C99.0725 87.6794 99.0725 85.7367 100.44 85.7367C101.807 85.7367 101.807 87.6794 100.44 87.6794Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.789 85.3158C101.422 85.3158 101.422 83.3731 102.789 83.3731C104.157 83.3731 104.157 85.3158 102.789 85.3158Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.349 82.8551C103.981 82.8551 103.981 80.9125 105.349 80.9125C106.716 80.9125 106.716 82.8551 105.349 82.8551Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.14 80.4591C101.772 80.4591 101.772 78.5165 103.14 78.5165C104.472 78.5165 104.472 80.4591 103.14 80.4591Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.545 82.9523C99.1777 82.9523 99.1777 81.0096 100.545 81.0096C101.913 81.0096 101.913 82.9523 100.545 82.9523Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9856 85.3158C96.6182 85.3158 96.6182 83.3731 97.9856 83.3731C99.353 83.3731 99.353 85.3158 97.9856 85.3158Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.1806 87.4851C93.8132 87.4851 93.8132 85.5424 95.1806 85.5424C96.548 85.5424 96.548 87.4851 95.1806 87.4851Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.708 83.5674C93.743 83.5997 93.7781 83.6322 93.8132 83.6645C94.1989 84.0207 94.2339 84.6682 93.8132 85.0244C93.3924 85.3806 92.7262 85.4129 92.3405 85.0244C92.3055 84.992 92.2704 84.9596 92.2354 84.9272C91.8497 84.571 91.8146 83.9236 92.2354 83.5674C92.621 83.2112 93.2872 83.1788 93.708 83.5674Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.0754 83.0494C93.7079 83.0494 93.7079 81.1067 95.0754 81.1067C96.4428 81.1067 96.4428 83.0494 95.0754 83.0494Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.0038 78.7107C97.0389 78.6784 97.074 78.6459 97.109 78.6136C97.4947 78.2574 98.196 78.225 98.5817 78.6136C98.9673 79.0021 99.0024 79.6173 98.5817 79.9734C98.5466 80.0058 98.5115 80.0381 98.4765 80.0706C98.0908 80.4267 97.3895 80.4591 97.0038 80.0706C96.6182 79.682 96.6182 79.0992 97.0038 78.7107Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.44 77.9984C99.0725 77.9984 99.0725 76.0558 100.44 76.0558C101.807 76.0558 101.807 77.9984 100.44 77.9984Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.333 76.1529C100.966 76.1529 100.966 74.2103 102.333 74.2103C103.701 74.2103 103.701 76.1529 102.333 76.1529Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.545 73.7569C99.1777 73.7569 99.1777 71.8143 100.545 71.8143C101.913 71.8143 101.913 73.7569 100.545 73.7569Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.7752 75.732C96.4078 75.732 96.4078 73.7894 97.7752 73.7894C99.1076 73.7894 99.1076 75.732 97.7752 75.732Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.1287 77.3185C94.1287 77.2862 94.1287 77.2537 94.1287 77.2214C94.1287 76.7034 94.6195 76.2177 95.1805 76.2501C95.7415 76.2824 96.2324 76.6709 96.2324 77.2214C96.2324 77.2537 96.2324 77.2862 96.2324 77.3185C96.2324 77.8365 95.7415 78.3222 95.1805 78.2899C94.6195 78.2899 94.1287 77.869 94.1287 77.3185Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.8314 80.5886C91.4639 80.5886 91.4639 78.6459 92.8314 78.6459C94.1988 78.6459 94.1988 80.5886 92.8314 80.5886Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.8328 78.2898C89.4654 78.2898 89.4654 76.3472 90.8328 76.3472C92.2003 76.3472 92.2003 78.2898 90.8328 78.2898Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.9717 75.732C91.6042 75.732 91.6042 73.7894 92.9717 73.7894C94.304 73.7894 94.304 75.732 92.9717 75.732Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5831 72.2676C96.5831 72.2999 96.5831 72.3322 96.5831 72.3647C96.5831 72.8827 96.0922 73.3684 95.5312 73.336C94.9702 73.3036 94.4793 72.915 94.4793 72.3647C94.4793 72.3322 94.4793 72.2999 94.4793 72.2676C94.4793 71.7494 94.9702 71.2638 95.5312 71.2962C96.0922 71.3286 96.5831 71.7171 96.5831 72.2676Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.8804 71.1991C96.513 71.1991 96.513 69.2565 97.8804 69.2565C99.2128 69.2565 99.2478 71.1991 97.8804 71.1991Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9856 66.2453C96.6182 66.2453 96.6182 64.3026 97.9856 64.3026C99.353 64.3026 99.353 66.2453 97.9856 66.2453Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.426 68.6089C95.391 68.6089 95.3559 68.6089 95.3208 68.6089C94.7598 68.6089 94.2339 68.1556 94.269 67.6376C94.304 67.1195 94.7248 66.6663 95.3208 66.6663C95.3559 66.6663 95.391 66.6663 95.426 66.6663C95.987 66.6663 96.513 67.1195 96.4779 67.6376C96.4428 68.1556 96.0221 68.6089 95.426 68.6089Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.7262 71.1991C92.6911 71.1991 92.6561 71.1991 92.621 71.1991C92.06 71.1991 91.5341 70.7458 91.5691 70.2278C91.6042 69.7097 92.0249 69.2565 92.621 69.2565C92.6561 69.2565 92.6911 69.2565 92.7262 69.2565C93.2872 69.2565 93.8131 69.7097 93.7781 70.2278C93.7781 70.7458 93.3223 71.1991 92.7262 71.1991Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.5677 65.5654C93.5677 65.5977 93.5677 65.6301 93.5677 65.6625C93.5677 66.1805 93.0768 66.6662 92.5158 66.6339C91.9548 66.6014 91.4639 66.2129 91.4639 65.6625C91.4639 65.6301 91.4639 65.5977 91.4639 65.5654C91.4639 65.0474 91.9548 64.5617 92.5158 64.5941C93.0768 64.6264 93.5677 65.0149 93.5677 65.5654Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.9702 64.076C93.6028 64.076 93.6028 62.1334 94.9702 62.1334C96.3376 62.1334 96.3376 64.076 94.9702 64.076Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.7262 61.8096C91.3588 61.8096 91.3588 59.8669 92.7262 59.8669C94.0936 59.8669 94.0936 61.8096 92.7262 61.8096Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.9702 59.7373C93.6028 59.7373 93.6028 57.7947 94.9702 57.7947C96.3376 57.7947 96.3376 59.7373 94.9702 59.7373Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.621 57.2444C91.2536 57.2444 91.2536 55.3017 92.621 55.3017C93.9885 55.3017 93.9885 57.2444 92.621 57.2444Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5523 53.3265C94.9352 55.5606 97.2142 59.705 98.792 63.8817C100.791 69.1269 102.614 74.1779 105.91 78.905C106.681 80.0058 107.488 81.0742 108.329 82.1104C108.925 82.8226 109.907 83.6645 109.977 84.6358C110.117 86.2223 107.663 87.6145 106.506 88.4564C102.474 91.3056 97.7051 93.119 92.6912 93.7991C92.2003 93.8636 91.9899 93.1512 92.4808 93.0867C97.2142 92.4711 101.702 90.8199 105.559 88.1973C106.611 87.485 107.663 86.708 108.539 85.8338C109.696 84.7006 108.61 83.6645 107.803 82.6932C106.33 80.9124 104.998 79.0669 103.771 77.1242C101.422 73.336 99.914 69.3212 98.4063 65.2092C96.7935 60.8058 94.6897 56.3053 90.0965 53.9741C89.7108 53.7151 90.1316 53.0999 90.5523 53.3265Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.68 88.0031C113.027 92.1799 118.532 94.9971 124.142 97.5222C130.033 100.145 136.063 102.897 142.55 103.933C146.056 104.484 149.598 104.451 153.069 103.706C156.119 103.027 158.959 102.282 162.115 102.476C165.341 102.67 168.531 103.415 171.687 103.998C173.195 104.289 174.737 104.548 176.245 104.839C177.157 105.002 178.314 105.098 179.05 105.746C180.453 106.977 178.945 108.304 177.612 108.693C174.246 109.696 170.39 109.178 166.918 108.822C166.428 108.757 166.428 108.045 166.918 108.077C170.004 108.401 173.16 108.757 176.245 108.239C176.771 108.142 178.314 107.948 178.524 107.43C178.629 107.171 177.788 105.973 177.612 105.875C177.472 105.779 177.192 105.779 177.016 105.746C175.509 105.422 173.966 105.195 172.458 104.904C169.373 104.322 166.252 103.641 163.132 103.318C159.906 102.994 157.031 103.577 153.945 104.289C143.006 106.847 132.592 102.184 122.985 97.8135C117.585 95.3529 112.361 92.5688 108.154 88.5535C107.768 88.1973 108.329 87.6793 108.68 88.0031Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.99 107.657C166.953 107.883 168.496 108.952 170.249 109.728C172.704 110.83 175.368 111.444 177.963 112.124C180.838 112.837 185.992 113.97 184.835 117.79C184.695 118.244 183.924 118.049 184.064 117.597C185.291 113.614 177.542 112.837 174.807 112.092C173.3 111.671 171.827 111.218 170.39 110.635C168.601 109.891 166.953 108.628 164.99 108.401C164.499 108.336 164.499 107.591 164.99 107.657Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.181 113.355C172.388 114.229 176.631 115.006 180.803 116.042C182.942 116.56 186.659 117.79 185.922 120.478C185.782 120.931 185.046 120.737 185.151 120.284C185.992 117.208 179.085 116.431 176.981 115.978C173.966 115.33 170.986 114.715 167.97 114.067C167.479 113.938 167.69 113.226 168.181 113.355Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.199 116.14C171.406 117.888 176 118.308 180.523 119.086C181.785 119.313 187.43 120.154 185.046 122.518C184.695 122.874 184.134 122.356 184.485 122C184.38 120.996 183.889 120.413 183.012 120.316C182.626 120.219 182.206 120.154 181.82 120.057C181.014 119.895 180.207 119.765 179.401 119.636C177.963 119.41 176.561 119.215 175.123 118.956C172.248 118.47 169.478 117.856 166.813 116.754C166.322 116.592 166.743 115.978 167.199 116.14Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.848 119.021C170.109 120.64 173.791 120.834 177.402 121.288C178.454 121.417 182.661 121.935 181.084 123.91C180.593 124.525 179.646 124.557 178.91 124.557C176.911 124.557 174.878 124.396 172.879 124.298C169.688 124.136 166.498 123.845 163.728 122.291C163.307 122.065 163.693 121.417 164.113 121.676C166.428 122.971 169.022 123.359 171.687 123.521C172.949 123.586 174.211 123.651 175.474 123.684C176.14 123.716 176.841 123.748 177.507 123.78C177.963 123.813 178.419 123.813 178.875 123.845C179.401 123.975 179.576 123.716 179.366 123.1C179.471 122.032 179.12 122.291 178.103 122.129C177.367 122.032 176.631 121.935 175.859 121.838C174.843 121.708 173.826 121.611 172.844 121.482C170.6 121.158 168.426 120.64 166.428 119.636C166.007 119.442 166.428 118.827 166.848 119.021Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.466 121.838C184.87 123.748 182.521 123.651 180.803 123.359C180.312 123.263 180.523 122.582 181.014 122.647C182.276 122.874 184.239 123.133 184.695 121.643C184.835 121.19 185.607 121.384 185.466 121.838Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.838 87.3232C108.154 87.6146 108.469 87.8736 108.785 88.165C109.135 88.4888 108.574 89.0069 108.224 88.6831C107.908 88.3917 107.593 88.1327 107.277 87.8413C106.926 87.5175 107.487 86.9994 107.838 87.3232Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.2689 93.5402C97.8102 98.5904 102.579 102.768 108.259 105.779C108.715 106.005 108.294 106.653 107.873 106.393C102.088 103.318 97.2142 99.076 93.6027 93.8959C93.3222 93.507 93.9884 93.1513 94.2689 93.5402Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.9731 73.336C89.6757 80.0706 92.621 86.6432 93.4976 93.248C93.5677 93.8313 92.6561 93.8313 92.4808 93.3779C91.5341 91.2409 90.9731 89.0392 90.7276 86.7728C90.6575 86.1575 91.7094 86.1575 91.7795 86.7728C92.0249 88.9744 92.621 91.079 93.4976 93.119C93.1469 93.1512 92.7963 93.2157 92.4808 93.248C91.6042 86.5137 88.6589 79.9411 89.9913 73.077C90.0614 72.4618 91.0782 72.7208 90.9731 73.336Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.8496 70.9401C90.3069 74.6959 90.8328 78.387 91.8146 82.2076C92.7262 85.769 93.9534 89.2658 95.4611 92.6333C95.5663 92.86 95.3559 93.1835 95.1104 93.2158C94.4443 93.378 94.5144 93.378 93.8131 93.3457C93.4976 93.3457 93.3222 93.119 93.2872 92.8601C93.1119 91.1762 92.621 89.622 91.8146 88.1002C92.1301 87.9708 92.4457 87.8413 92.7612 87.7117C93.4274 89.1687 93.9534 90.6257 94.3741 92.1475C94.5494 92.7624 93.5326 93.0213 93.3573 92.4066C92.9366 90.8848 92.4106 89.4278 91.7444 87.9708C91.499 87.4528 92.4457 87.0966 92.6911 87.5822C93.5677 89.2658 94.0936 90.9819 94.304 92.8278C94.1287 92.6656 93.9534 92.5034 93.7781 92.3421C94.1287 92.3089 94.4793 92.2767 94.7949 92.2767C94.6897 92.4711 94.5494 92.6656 94.4443 92.8601C92.7613 89.104 91.3938 85.2187 90.4822 81.2362C89.6407 77.6099 89.3953 74.1455 90.8328 70.6487C91.0782 70.0982 92.0951 70.3573 91.8496 70.9401Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.698 88.2621C105.875 89.8811 103.911 91.3704 101.737 92.6011C99.8088 93.6692 97.2142 95.0617 94.9351 94.8027C94.4443 94.7373 94.1637 94.1548 94.6546 93.8959C94.7247 93.8636 94.8299 93.8314 94.9001 93.7659C95.4961 93.4747 96.0221 94.317 95.426 94.6082C95.3559 94.6405 95.2507 94.6728 95.1806 94.7373C95.0754 94.4461 95.0052 94.1226 94.9001 93.8314C97.1791 94.0581 99.7737 92.5688 101.667 91.4675C103.56 90.3343 105.279 89.0069 106.926 87.5499C107.452 87.1613 108.189 87.8413 107.698 88.2621Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.525 90.7229C101.281 92.6333 97.8103 94.705 94.6546 94.2848C94.1287 94.2194 94.1638 93.4425 94.6546 93.3457C96.9337 92.9246 99.1076 92.2767 101.211 91.3704C101.807 91.1115 102.368 91.9532 101.737 92.2122C99.5984 93.1513 97.3544 93.8314 95.0053 94.2516C94.3391 94.3816 94.0586 93.4425 94.7248 93.3135C96.9688 92.9245 99.1076 92.2767 101.176 91.3704C101.352 91.6618 101.527 91.9209 101.702 92.2122C99.5283 93.1513 97.2493 93.8314 94.9001 94.2848C94.9001 93.9604 94.9001 93.6692 94.9001 93.3457C97.5648 93.6692 100.896 91.6295 102.754 90.0106C103.28 89.622 104.016 90.302 103.525 90.7229Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.75 107.948C163.973 116.485 164.482 125.261 163.243 133.977C163.148 134.542 162.258 134.304 162.322 133.739C163.56 125.202 163.052 116.544 160.829 108.186C160.67 107.62 161.591 107.382 161.75 107.948Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.22 134.854C158.153 136.311 153.489 136.537 149.177 136.861C144.549 137.185 139.92 137.315 135.327 137.217C130.699 137.12 126.071 136.764 121.513 136.213C119.444 135.954 117.41 135.663 115.342 135.34C113.448 135.015 111.59 134.692 110.012 133.591C109.486 133.203 110.012 132.36 110.538 132.749C112.116 133.85 114.044 134.142 115.938 134.433C118.217 134.789 120.531 135.113 122.845 135.372C127.228 135.858 131.611 136.149 135.993 136.213C140.271 136.278 144.584 136.181 148.861 135.89C153.209 135.566 157.837 135.372 161.94 133.915C162.571 133.688 162.816 134.627 162.22 134.854Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.067 108.114C150.9 104.969 140.129 103.902 129.579 104.993C128.946 105.063 128.798 104.135 129.463 104.079C140.196 102.998 151.136 104.101 161.473 107.284C162.105 107.448 161.7 108.278 161.067 108.114Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.673 105.02C122.011 104.839 112.377 105.41 102.85 106.733C102.193 106.829 101.974 105.876 102.631 105.78C112.268 104.441 122.011 103.853 131.72 104.049C132.394 104.053 132.347 105.025 131.673 105.02Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.894 106.005C102.859 105.973 102.859 105.973 102.824 105.941C102.579 105.779 102.649 105.422 102.824 105.261C102.859 105.228 102.894 105.195 102.929 105.163C103.105 104.969 103.49 104.969 103.666 105.163C104.262 105.811 103.806 106.912 103.701 107.689C103.49 109.146 103.28 110.603 103.07 112.06C102.684 115.168 102.474 118.276 102.824 121.417C102.894 122.032 101.842 122.032 101.772 121.417C101.457 118.697 101.562 116.01 101.878 113.323C102.018 112.06 102.193 110.83 102.368 109.566C102.439 109.016 103.07 106.486 102.824 106.195C103.07 106.195 102.649 106.005 102.894 106.005L103.599 106.672C103.599 106.672 103.599 106.167 103.599 105.941H103.387C103.913 106.329 103.42 106.393 102.894 106.005Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.768 37.1447C150.747 41.9394 154.455 48.6855 155.141 55.9543C155.198 56.4965 154.276 56.4844 154.218 55.9423C153.535 48.907 149.881 42.3527 144.113 37.7416C143.663 37.3816 144.318 36.7848 144.768 37.1447Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.583 56.6739C152.039 55.9693 148.902 56.8708 146.309 57.2314C143.591 57.5933 140.842 57.9622 138.117 58.4134C132.526 59.3789 127.285 61.138 122.479 63.9923C121.991 64.2853 121.53 63.5477 122.018 63.2546C127.067 60.2538 132.583 58.4578 138.457 57.4828C141.338 57.0234 144.272 56.6389 147.169 56.2342C149.613 55.9093 152.35 55.1626 154.79 55.8339C155.409 56.0068 155.165 56.8265 154.583 56.6739Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.817 38.2159C133.57 37.5575 122.304 40.7671 113.445 47.2312C112.973 47.5791 112.327 46.9737 112.799 46.6258C121.843 40.0295 133.323 36.6805 144.83 37.3639C145.411 37.3998 145.398 38.2517 144.817 38.2159Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.104 46.5819C117.189 51.7444 120.351 57.4514 122.452 63.5599C122.629 64.0735 121.738 64.2878 121.562 63.7742C119.454 57.7552 116.345 52.1232 112.305 47.0083C111.958 46.565 112.765 46.166 113.104 46.5819Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.328 41.8911C139.251 42.307 132.254 43.3474 125.398 44.9978C124.834 45.1335 124.602 44.3113 125.166 44.1756C132.112 42.5037 139.205 41.4693 146.341 41.0391C146.936 41.0129 146.923 41.8649 146.328 41.8911Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.717 44.5711C144.552 44.9234 141.434 45.5568 138.386 46.4369C137.83 46.6001 137.598 45.7778 138.155 45.6147C141.203 44.7346 144.291 44.1083 147.486 43.7489C148.043 43.7026 148.304 44.5177 147.717 44.5711Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.215 49.3843C142.476 50.6032 134.746 51.8496 127.007 53.0685C126.428 53.1495 126.196 52.3273 126.776 52.2463C134.514 51.0273 142.245 49.781 149.983 48.5621C150.562 48.4811 150.794 49.3034 150.215 49.3843Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.398 117.726C152.473 117.597 146.582 117.629 140.657 117.888C139.99 117.92 139.99 116.949 140.657 116.917C146.547 116.69 152.473 116.625 158.398 116.754C159.064 116.754 159.064 117.726 158.398 117.726Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.5638 116.56C76.2468 114.229 75.3352 111.348 73.6873 109.21C72.8458 108.109 71.6536 106.944 70.2161 106.588C68.498 106.167 66.9202 107.106 65.7982 108.271C62.1868 112.124 61.2752 117.79 60.8544 122.679C60.4687 127.439 60.5388 132.199 59.8376 136.926C59.5921 138.479 59.2766 140.455 57.4183 141.038C55.7002 141.588 53.9822 140.488 53.1407 139.192C51.8083 137.12 51.5628 134.238 51.3174 131.875C51.0369 128.864 51.2473 125.82 51.8083 122.841C51.9134 122.227 52.9303 122.486 52.8251 123.1C52.2641 125.982 52.0888 128.928 52.3693 131.875C52.5446 133.817 52.9303 139.97 56.0158 140.163C59.4168 140.39 59.1013 134.433 59.2415 132.296C59.4168 129.9 59.487 127.471 59.5921 125.075C59.8376 120.51 60.3635 115.815 62.3971 111.574C63.9048 108.434 67.1656 103.868 71.5134 106.038C75.3703 107.98 77.9999 113.452 75.4053 117.046C75.1248 117.564 74.2132 117.078 74.5638 116.56Z",
    fill: "#FF4F79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.456 89.2218C171.821 88.1234 174.763 82.4842 172.052 77.8251C169.086 72.764 161.423 72.6368 156.109 73.0871C143.17 74.2101 134.241 82.8597 124.656 90.1183C119.393 94.1189 113.634 97.7028 106.842 98.8465C106.301 98.9377 106.461 99.745 107.001 99.6538C117.35 97.9102 125.055 90.8018 132.843 84.7078C136.914 81.5196 141.183 78.4373 146.067 76.3912C151.984 73.9208 159.238 72.8658 165.628 74.4308C169.088 75.2937 171.86 77.5794 172.203 81.1083C172.541 84.6101 169.827 87.6808 166.3 88.4141C165.759 88.505 165.89 89.3171 166.459 89.2214L166.456 89.2218Z",
    fill: "#FF4F79"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1,
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2708_26814",
    transform: "scale(0.01)",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2708_26814",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 234,
    height: 141,
    fill: "white"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2708_26814",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAzNJREFUeAHt3M2OozAMwHG61z3P+/W+LzXvN+c5zzhIRbCBJI6wncI/EuoXBce/GI3GbR8/0/RvmqbPxzR9y23XkGP8lTc+ZfuQ7Us2jidJaB3r/D3SAzBaUzdN6+TJu05ffGLRP6yDk8juWGl9IGDYLJauCgHDBiOVhhoEDDsMNQgYthgqEDDsMZpBwPDBaAIBww+jCgKGL0YRBAx/jEMQMGIwdkHAiMPIQMCIxdiAgBGPsYCAMQbGDALGOBgJ5I9sT9no9EkStMNiMScQMLQSsr8Fhhz2mUBOb0PKMe/Y6TvlMwn01GX1aIZVZUgM85VK3aBaB28dnJzrjpW2TnH7fTBsFktXhYBhg5HKQQ0Chh2GGgQMWwwVCBj2GM0gYPhgNIGA4YdRBQHDF6MIAoY/xiEIGDEYuyBgxGFkIGDEYmxAwIjHWEDAGANjBgFjHIwEQk99sG8f01NPy7JjWF1Z6KkPhCGhfNBTV4JYVUbCkO1L3aBax28dnJyLnvo64aX7YNgslq4KAcMGIxWAGgQMOww1CBi2GCoQMOwxmkHA8MFoAgHDD6MKAoYvRhEEDH+MQxAwYjB2QcCIw8hAwIjF2ICAEY+xgIAxBsYMAsY4GAmEnjo99bQO6uOulUtPvb42sj0sFws99Szd5ScsMeTM9NTL6d++ao0hZ0ufIegbTsGd8nMVMsO3+fmQLhAw7P5UVoOAYYeRrlUqEDBsMVQgYNhjNIOA4YPRBAKGH0YVBAxfjCIIGP4YhyBgxGDsgoARh5GBgBGLsQEBIx5jAQFjDIwZBIxxMBIIPXV66mkd1MddK5eeen1tZHtYLhZ66lm6y09YYsiZ6amX07991RpDzkZPfZvy40dOGN+qjuErXK/gXufT3r5zfGqQd56sFjbt7z1fFYh3cNoEXiG+ZpArTFYDHDXfJpCo4FoTeKX4qiBXmmwLcPR8iyDRwdUSeMX4DkGuONkS8Cjz3QUZJbijBF45vgzkypPdAx5tvhuQ0YL7P4F3iG8BucNk18CjzncGGTW4VwLvFN/cD5GJP2WbfzdWbtO/gG/3zSWZd9c4e7HQUx9s8SUQKqOjNs6ujNfxfgGAxM6f6FnQSQAAAABJRU5ErkJggg==",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegmentsBannerDarkLeft);
export default __webpack_public_path__ + "static/media/segmentsBannerDarkLeft.54d28538c3a93935ede7ad45167137a4.svg";
export { ForwardRef as ReactComponent };